export const publicationsData =  [
    {
        'Author Name EN': 'Dr. Ibtesam Mohammed Alawadhi',
        'Author Name AR': 'د. ابتسام محمد العوضي',
        'Research Title EN': 'Forecasting Cyber Crimes in the Age of the Metaverse',
        'Research Title AR': 'Forecasting Cyber Crimes in the Age of the Metaverse',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Advances in Digital Crime, Forensics, and Cyber Terrorism',
        'Journal Label AR': ' Advances in Digital Crime, Forensics, and Cyber Terrorism',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.4018/979-8-3693-0220-0',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Ibtesam Mohammed Alawadhi',
        'Author Name AR': 'د. ابتسام محمد العوضي',
        'Research Title EN': 'Digital forensic intelligence for illicit drug analysis in forensic investigations',
        'Research Title AR': 'Digital forensic intelligence for illicit drug analysis in forensic investigations',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' iScience',
        'Journal Label AR': ' iScience',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.isci.2023.108023',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Ibtesam Mohammed Alawadhi',
        'Author Name AR': 'د. ابتسام محمد العوضي',
        'Research Title EN': 'Factors Influencing Digital Forensic Investigations: Empirical Evaluation of 12 Years of Dubai Police Cases',
        'Research Title AR': 'Factors Influencing Digital Forensic Investigations: Empirical Evaluation of 12 Years of Dubai Police Cases',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2015,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Journal of Digital Forensics, Security and Law',
        'Journal Label AR': ' Journal of Digital Forensics, Security and Law',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.15394/jdfsl.2015.1207',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'A journey into the innovations and expertise of Dubai police and the general department of forensic science and criminology',
        'Research Title AR': 'A journey into the innovations and expertise of Dubai police and the general department of forensic science and criminology',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' World Journal of Advanced Research and Reviews',
        'Journal Label AR': ' World Journal of Advanced Research and Reviews',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.30574/wjarr.2024.22.2.1558',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'Evaluation of microFLOQ™ Direct Swab for Touch DNA Recovery',
        'Research Title AR': 'Evaluation of microFLOQ™ Direct Swab for Touch DNA Recovery',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Journal of Forensic, Legal & Investigative Sciences',
        'Journal Label AR': ' Journal of Forensic, Legal & Investigative Sciences',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.24966/flis-733x/100093',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'Collection techniques of touch DNA deposited on human skin following a strangulation scenario',
        'Research Title AR': 'Collection techniques of touch DNA deposited on human skin following a strangulation scenario',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' International journal of legal medicine',
        'Journal Label AR': ' International journal of legal medicine',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.24966/flis-733x/100093',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'The role of DNA in forensic science: A comprehensive review',
        'Research Title AR': 'The role of DNA in forensic science: A comprehensive review',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'SSRN Electronic Journal',
        'Journal Label AR': 'SSRN Electronic Journal',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.2139/ssrn.4550489 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'Maintaining the chain of custody: Anti-contamination measures for trace DNA evidence',
        'Research Title AR': 'Maintaining the chain of custody: Anti-contamination measures for trace DNA evidence',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' International Journal of Science and Research Archive',
        'Journal Label AR': ' International Journal of Science and Research Archive',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.2139/ssrn.4399634 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'An Evaluation of the Performance of Two Quantification Methods for Trace DNA Casework Samples',
        'Research Title AR': 'An Evaluation of the Performance of Two Quantification Methods for Trace DNA Casework Samples',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of Forensic Sciences & Criminal Investigation',
        'Journal Label AR': 'Journal of Forensic Sciences & Criminal Investigation',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.19080/JFSCI.2023.16.555950',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'Collection Methods for Touch DNA Direct Amplification',
        'Research Title AR': 'Collection Methods for Touch DNA Direct Amplification',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic, Legal &amp; Investigative Sciences',
        'Journal Label AR': 'Forensic, Legal &amp; Investigative Sciences',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.24966/flis-733x/100072 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'Analysis of Touch DNA',
        'Research Title AR': 'Analysis of Touch DNA',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'SSRN Electronic Journal',
        'Journal Label AR': 'SSRN Electronic Journal',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.2139/ssrn.4477578 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'The impact of deposition area and time on Touch DNA collected from fabric',
        'Research Title AR': 'The impact of deposition area and time on Touch DNA collected from fabric',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2022.09.017',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'Dual Recovery of DNA and Fingerprints using Minitapes',
        'Research Title AR': 'Dual Recovery of DNA and Fingerprints using Minitapes',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of Forensic Sciences & Criminal Investigation',
        'Journal Label AR': 'Journal of Forensic Sciences & Criminal Investigation',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': ' 10.19080/JFSCI.2022.16.555929',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'An Innovative Solution to Collect Touch DNA for Direct Amplification',
        'Research Title AR': 'An Innovative Solution to Collect Touch DNA for Direct Amplification',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Journal of Forensic, Legal & Investigative Sciences',
        'Journal Label AR': ' Journal of Forensic, Legal & Investigative Sciences',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.24966/FLIS-733X/100072',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'The Impact of Area Size and Fabric Type on Touch DNA Collected from Fabric',
        'Research Title AR': 'The Impact of Area Size and Fabric Type on Touch DNA Collected from Fabric',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of Forensic Sciences & Criminal Investigation',
        'Journal Label AR': 'Journal of Forensic Sciences & Criminal Investigation',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.19080/JFSCI.2022.16.555926',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'The Impact of Collection Method on Touch DNA Collected from Fabric',
        'Research Title AR': 'The Impact of Collection Method on Touch DNA Collected from Fabric',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Journal of Forensic Sciences & Criminal Investigation',
        'Journal Label AR': ' Journal of Forensic Sciences & Criminal Investigation',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.19080/jfsci.2022.15.555923',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'Touch DNA collection techniques for non-porous surfaces using cotton and nylon swabs',
        'Research Title AR': 'Touch DNA collection techniques for non-porous surfaces using cotton and nylon swabs',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Biomedical Journal of Scientific &amp; Technical Research',
        'Journal Label AR': 'Biomedical Journal of Scientific &amp; Technical Research',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.26717/bjstr.2021.36.005863 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'Collection of Touch DNA from Rotten Banana Skin',
        'Research Title AR': 'Collection of Touch DNA from Rotten Banana Skin',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' International Journal of Forensic Sciences',
        'Journal Label AR': ' International Journal of Forensic Sciences',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.23880/ijfsc-16000204 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'The effect of surface type, collection and extraction methods on touch DNA',
        'Research Title AR': 'The effect of surface type, collection and extraction methods on touch DNA',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.10.145',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'The effect of time and environmental conditions on Touch DNA',
        'Research Title AR': 'The effect of time and environmental conditions on Touch DNA',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.10.144',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'The Effect of Sandy Surfaces on Touch DNA',
        'Research Title AR': 'The Effect of Sandy Surfaces on Touch DNA',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Journal of Forensic, Legal & Investigative Sciences',
        'Journal Label AR': ' Journal of Forensic, Legal & Investigative Sciences',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.24966/flis-733x/100034',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Khalifa Al Ketbi',
        'Author Name AR': 'سالم خليفة الكتبي',
        'Research Title EN': 'The affecting factors of touch DNA',
        'Research Title AR': 'The affecting factors of touch DNA',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Journal of Forensic Research',
        'Journal Label AR': ' Journal of Forensic Research',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.4172/2157-7145.1000424',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hamad Saeed Rashed',
        'Author Name AR': 'د. حمد سعيد راشد',
        'Research Title EN': 'Pocket-size near-IR spectrometers for rapid examination of contaminated textile fibres at the crime-scene',
        'Research Title AR': 'Pocket-size near-IR spectrometers for rapid examination of contaminated textile fibres at the crime-scene',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Vibrational Spectroscopy',
        'Journal Label AR': 'Vibrational Spectroscopy',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': ' 10.1016/j.vibspec.2022.103464',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hamad Saeed Rashed',
        'Author Name AR': 'د. حمد سعيد راشد',
        'Research Title EN': 'A comparative investigation of two handheld near-ir spectrometers for direct forensic examination of fibres in-situ',
        'Research Title AR': 'A comparative investigation of two handheld near-ir spectrometers for direct forensic examination of fibres in-situ',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Vibrational Spectroscopy',
        'Journal Label AR': 'Vibrational Spectroscopy',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': ' 10.1016/j.vibspec.2020.103205',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed Naji',
        'Author Name AR': 'محمد ناجي',
        'Research Title EN': 'Design and development of novel single multiplex system incorporating 26 rapidly mutating Y-STRs; 26 RM Yplex',
        'Research Title AR': 'Design and development of novel single multiplex system incorporating 26 rapidly mutating Y-STRs; 26 RM Yplex',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Electrophoresis',
        'Journal Label AR': ' Electrophoresis',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1002/elps.202200099',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed Naji',
        'Author Name AR': 'محمد ناجي',
        'Research Title EN': 'First confirmed detection of SARS-COV-2 in untreated municipal and aircraft wastewater in Dubai, UAE: The use of wastewater based epidemiology as an early warning tool to monitor the prevalence of COVID-19',
        'Research Title AR': 'First confirmed detection of SARS-COV-2 in untreated municipal and aircraft wastewater in Dubai, UAE: The use of wastewater based epidemiology as an early warning tool to monitor the prevalence of COVID-19',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Science of the total Enviroment',
        'Journal Label AR': 'Science of the total Enviroment',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.scitotenv.2020.143350',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed Naji',
        'Author Name AR': 'محمد ناجي',
        'Research Title EN': 'Population genetics data of 23 autosomal STR loci for three Populations in United Arab Emirates',
        'Research Title AR': 'Population genetics data of 23 autosomal STR loci for three Populations in United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.09.073',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ali Mohammed AlMatrooshi',
        'Author Name AR': 'على محمد المطروشي',
        'Research Title EN': 'Medical Negligence and Consumer Protection Laws: A Swift Analysis and Recommendations',
        'Research Title AR': 'Medical Negligence and Consumer Protection Laws: A Swift Analysis and Recommendations',
        'Department EN': 'General Department of Human Rights',
        'Department AR': 'الإدارة العامة لحقوق الإنسان',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Health Economics and Management Review',
        'Journal Label AR': ' Health Economics and Management Review',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.61093/hem.2024.2-01',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ali Mohammed AlMatrooshi',
        'Author Name AR': 'على محمد المطروشي',
        'Research Title EN': 'An in-depth analysis of the Human Rights Act of 1998 and the Bill of Human Rights UK, examining the advantages and disadvantages',
        'Research Title AR': 'An in-depth analysis of the Human Rights Act of 1998 and the Bill of Human Rights UK, examining the advantages and disadvantages',
        'Department EN': 'General Department of Human Rights',
        'Department AR': 'الإدارة العامة لحقوق الإنسان',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Current Trends in Law and Society',
        'Journal Label AR': ' Current Trends in Law and Society',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.52131/ctls.2024.0401.0039',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ali Mohammed AlMatrooshi',
        'Author Name AR': 'على محمد المطروشي',
        'Research Title EN': 'Right of Privacy and the Growing Scope of Artificial Intelligence',
        'Research Title AR': 'Right of Privacy and the Growing Scope of Artificial Intelligence',
        'Department EN': 'General Department of Human Rights',
        'Department AR': 'الإدارة العامة لحقوق الإنسان',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Current Trends in Law and Society',
        'Journal Label AR': ' Current Trends in Law and Society',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.52131/clts.2023.0301.0011',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ali Mohammed AlMatrooshi',
        'Author Name AR': 'على محمد المطروشي',
        'Research Title EN': 'Analyzing the Limitations of Agency and Rights in Migrant Women\'s Empowerment',
        'Research Title AR': 'Analyzing the Limitations of Agency and Rights in Migrant Women\'s Empowerment',
        'Department EN': 'General Department of Human Rights',
        'Department AR': 'الإدارة العامة لحقوق الإنسان',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Pakistan Journal of Humanities and Social Sciences',
        'Journal Label AR': ' Pakistan Journal of Humanities and Social Sciences',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.52131/pjhss.2023.1103.0582',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ali Mohammed AlMatrooshi',
        'Author Name AR': 'على محمد المطروشي',
        'Research Title EN': 'Assessment of mandatory reporting laws to break the silence of child sexual abuse: a case study in the United Arab Emirates',
        'Research Title AR': 'Assessment of mandatory reporting laws to break the silence of child sexual abuse: a case study in the United Arab Emirates',
        'Department EN': 'General Department of Human Rights',
        'Department AR': 'الإدارة العامة لحقوق الإنسان',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' SN Social Sciences',
        'Journal Label AR': ' SN Social Sciences',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1007/s43545-021-00216-4',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Afra Al Mansoori',
        'Author Name AR': 'عفراء المنصوري',
        'Research Title EN': 'Behavior Types from Cybersecurity Perspective: An Overview',
        'Research Title AR': 'Behavior Types from Cybersecurity Perspective: An Overview',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Studies in Computational Intelligence',
        'Journal Label AR': 'Studies in Computational Intelligence',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.1007/978-3-031-61463-7_10 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Afra Al Mansoori',
        'Author Name AR': 'عفراء المنصوري',
        'Research Title EN': 'Exploring the Frontiers of Cybersecurity Behavior: A Systematic Review of Studies and Theories',
        'Research Title AR': 'Exploring the Frontiers of Cybersecurity Behavior: A Systematic Review of Studies and Theories',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Applied Sciences',
        'Journal Label AR': 'Applied Sciences',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.3390/app13095700',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Afra Al Mansoori',
        'Author Name AR': 'عفراء المنصوري',
        'Research Title EN': 'Ecosystem of Health Care Software Engineering in 2050',
        'Research Title AR': 'Ecosystem of Health Care Software Engineering in 2050',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Lecture Notes on Data Engineering and Communications Technologies',
        'Journal Label AR': 'Lecture Notes on Data Engineering and Communications Technologies',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1007/978-3-031-03918-8_29 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Afra Al Mansoori',
        'Author Name AR': 'عفراء المنصوري',
        'Research Title EN': 'Suspicious Activity Detection of Twitter and Facebook using Sentimental Analysis',
        'Research Title AR': 'Suspicious Activity Detection of Twitter and Facebook using Sentimental Analysis',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'TEM Journal',
        'Journal Label AR': 'TEM Journal',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.18421/tem94-01 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Afra Al Mansoori',
        'Author Name AR': 'عفراء المنصوري',
        'Research Title EN': 'Critical Review of Knowledge Management in Healthcare',
        'Research Title AR': 'Critical Review of Knowledge Management in Healthcare',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Studies in Systems, Decision and Control',
        'Journal Label AR': 'Studies in Systems, Decision and Control',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1007/978-3-030-47411-9_6',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Afra Al Mansoori',
        'Author Name AR': 'عفراء المنصوري',
        'Research Title EN': 'Reliable Acquisition of RAM Dumps from Intel-Based Apple Mac Computers over FireWire',
        'Research Title AR': 'Reliable Acquisition of RAM Dumps from Intel-Based Apple Mac Computers over FireWire',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2011,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Lecture Notes of the Institute for Computer Sciences, Social Informatics and Telecommunications Engineering',
        'Journal Label AR': 'Lecture Notes of the Institute for Computer Sciences, Social Informatics and Telecommunications Engineering',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1007/978-3-642-19513-6_5',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed Ali Qassim',
        'Author Name AR': 'محمد على القاسم',
        'Research Title EN': 'Fatal automobile accident due to airbag misdeployment',
        'Research Title AR': 'Fatal automobile accident due to airbag misdeployment',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International journal of legal medicine',
        'Journal Label AR': 'International journal of legal medicine',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1007/s00414-020-02457-z',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed Ali Qassim',
        'Author Name AR': 'محمد على القاسم',
        'Research Title EN': 'A thermoanalytical, X-ray diffraction and petrographic approach to the forensic assessment of fire affected concrete in the United Arab Emirates',
        'Research Title AR': 'A thermoanalytical, X-ray diffraction and petrographic approach to the forensic assessment of fire affected concrete in the United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2016.03.015 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed Ali Qassim',
        'Author Name AR': 'محمد على القاسم',
        'Research Title EN': 'Fires and related incidents in Dubai, United Arab Emirates (2006-2013)',
        'Research Title AR': 'Fires and related incidents in Dubai, United Arab Emirates (2006-2013)',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2014,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Case Studies in Fire Safety',
        'Journal Label AR': 'Case Studies in Fire Safety',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1016/j.csfs.2014.10.001',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hossam Nabil Elshenraki',
        'Author Name AR': 'حسام الشركاني',
        'Research Title EN': 'استخدام العملات الرقمية المشفرة ( المخاطر – الحلول)',
        'Research Title AR': 'استخدام العملات الرقمية المشفرة ( المخاطر – الحلول)',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'مجلة الدراسات القانونية والاقتصادية',
        'Journal Label AR': 'مجلة الدراسات القانونية والاقتصادية',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.21608/JDL.2023.234442.1210',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hossam Nabil Elshenraki',
        'Author Name AR': 'حسام الشركاني',
        'Research Title EN': 'Forecasting Cyber Crimes in the Age of the Metaverse',
        'Research Title AR': 'Forecasting Cyber Crimes in the Age of the Metaverse',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Advances in Digital Crime, Forensics, and Cyber Terrorism',
        'Journal Label AR': ' Advances in Digital Crime, Forensics, and Cyber Terrorism',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.4018/979-8-3693-0220-0',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hossam Nabil Elshenraki',
        'Author Name AR': 'حسام الشركاني',
        'Research Title EN': 'ادارة الاستدلال في جرائم الطائرات بدون طيار',
        'Research Title AR': 'ادارة الاستدلال في جرائم الطائرات بدون طيار',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'مجلة الأمن والقانون',
        'Journal Label AR': 'مجلة الأمن والقانون',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.54000/0576-031-002-004',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Naill Mohammad Momani',
        'Author Name AR': 'نايل الموماني',
        'Research Title EN': 'Academic role in disasters and crises management: Opportunities and challenges',
        'Research Title AR': 'Academic role in disasters and crises management: Opportunities and challenges',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Emergency Management',
        'Journal Label AR': 'International Journal of Emergency Management',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1504/IJEM.2017.083113',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Naill Mohammad Momani',
        'Author Name AR': 'نايل الموماني',
        'Research Title EN': 'Emergency volunteering in Kingdom of Saudi Arabia: Current and future trends',
        'Research Title AR': 'Emergency volunteering in Kingdom of Saudi Arabia: Current and future trends',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Emergency Management',
        'Journal Label AR': 'International Journal of Emergency Management',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1504/IJEM.2017.083114',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Naill Mohammad Momani',
        'Author Name AR': 'نايل الموماني',
        'Research Title EN': 'Integrated framework for earthquake consequences management',
        'Research Title AR': 'Integrated framework for earthquake consequences management',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2012,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Disaster Prevention and Management: An International Journal',
        'Journal Label AR': 'Disaster Prevention and Management: An International Journal',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1108/09653561211219991',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Naill Mohammad Momani',
        'Author Name AR': 'نايل الموماني',
        'Research Title EN': 'Preparedness of schools in the Province of Jeddah to deal with earthquakes risks',
        'Research Title AR': 'Preparedness of schools in the Province of Jeddah to deal with earthquakes risks',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2012,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Disaster Prevention and Management: An International Journal',
        'Journal Label AR': 'Disaster Prevention and Management: An International Journal',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1108/09653561211256161',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Naill Mohammad Momani',
        'Author Name AR': 'نايل الموماني',
        'Research Title EN': 'Improving Jordan\'s law towards sustainable solid and hazardous waste management: Lessons from USA\'s environmental laws',
        'Research Title AR': 'Improving Jordan\'s law towards sustainable solid and hazardous waste management: Lessons from USA\'s environmental laws',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2010,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Disaster Prevention and Management: An International Journal',
        'Journal Label AR': 'Disaster Prevention and Management: An International Journal',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1108/09653561111141745',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Naill Mohammad Momani',
        'Author Name AR': 'نايل الموماني',
        'Research Title EN': 'Climate change in Jordan: A comprehensive examination approach',
        'Research Title AR': 'Climate change in Jordan: A comprehensive examination approach',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2009,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'American Journal of Environmental Sciences',
        'Journal Label AR': 'American Journal of Environmental Sciences',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.3844/ajes.2009.58.68',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Naill Mohammad Momani',
        'Author Name AR': 'نايل الموماني',
        'Research Title EN': 'Sensitivity of earthquake loss estimation model: how useful are the predictions',
        'Research Title AR': 'Sensitivity of earthquake loss estimation model: how useful are the predictions',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2003,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Risk Assessment and Management',
        'Journal Label AR': 'International Journal of Risk Assessment and Management',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1504/ijram.2003.003433 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Essa Basaeed',
        'Author Name AR': 'عيسى باسعيد',
        'Research Title EN': 'Supervised remote sensing image segmentation using boosted convolutional neural networks',
        'Research Title AR': 'Supervised remote sensing image segmentation using boosted convolutional neural networks',
        'Department EN': 'General Department of Artificial Intelligence',
        'Department AR': 'الإدارة العامة للذكاء الإصطناعي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Knowledge-Based Systems',
        'Journal Label AR': 'Knowledge-Based Systems',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.knosys.2016.01.028',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Essa Basaeed',
        'Author Name AR': 'عيسى باسعيد',
        'Research Title EN': 'A supervised hierarchical segmentation of remote-sensing images using a committee of multi-scale convolutional neural networks',
        'Research Title AR': 'A supervised hierarchical segmentation of remote-sensing images using a committee of multi-scale convolutional neural networks',
        'Department EN': 'General Department of Artificial Intelligence',
        'Department AR': 'الإدارة العامة للذكاء الإصطناعي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Remote Sensing',
        'Journal Label AR': 'International Journal of Remote Sensing',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1080/01431161.2016.1159745',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Essa Basaeed',
        'Author Name AR': 'عيسى باسعيد',
        'Research Title EN': 'A spectral water index based on visual bands',
        'Research Title AR': 'A spectral water index based on visual bands',
        'Department EN': 'General Department of Artificial Intelligence',
        'Department AR': 'الإدارة العامة للذكاء الإصطناعي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2013,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'SPIE Proceedings',
        'Journal Label AR': 'SPIE Proceedings',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1117/12.2028638 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Jorge Javier Roman Garate',
        'Author Name AR': 'Jorge Javier Roman Garate',
        'Research Title EN': 'Community Engagement: Key element in a society safety\' Dubai Police - Case Study',
        'Research Title AR': 'Community Engagement: Key element in a society safety\' Dubai Police - Case Study',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Boletim IBCCRIM',
        'Journal Label AR': 'Boletim IBCCRIM',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.5281/ZENODO.11175692',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Jorge Javier Roman Garate',
        'Author Name AR': 'Jorge Javier Roman Garate',
        'Research Title EN': 'An Artificial Intelligence (AI) Framework to Predict Operational Excellence: UAE Case Study',
        'Research Title AR': 'An Artificial Intelligence (AI) Framework to Predict Operational Excellence: UAE Case Study',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Applied Sciences',
        'Journal Label AR': 'Applied Sciences',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.3390/app14062569',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Jorge Javier Roman Garate',
        'Author Name AR': 'Jorge Javier Roman Garate',
        'Research Title EN': 'Evolution and trends of intellectual property crime research between 1991 and 2020',
        'Research Title AR': 'Evolution and trends of intellectual property crime research between 1991 and 2020',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Business Environment',
        'Journal Label AR': 'International Journal of Business Environment',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1504/ijbe.2022.10052596',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Reconciling evidence from ancient and contemporary genomes: A major source for the European Neolithic within Mediterranean Europe',
        'Research Title AR': 'Reconciling evidence from ancient and contemporary genomes: A major source for the European Neolithic within Mediterranean Europe',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'the Royal Society B: Biological Sciences',
        'Journal Label AR': 'the Royal Society B: Biological Sciences',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1098/rspb.2016.1976 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hussain Alghanim',
        'Author Name AR': 'د. حسين الغانم ',
        'Research Title EN': 'Detection and evaluation of DNA methylation markers found at SCGN and KLF14 loci to estimate human age',
        'Research Title AR': 'Detection and evaluation of DNA methylation markers found at SCGN and KLF14 loci to estimate human age',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.fsigen.2017.07.011',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Suaad Alshehhi',
        'Author Name AR': 'د. سعاد الشحي ',
        'Research Title EN': 'Quantification of RNA degradation of blood-specific markers to indicate the age of bloodstains',
        'Research Title AR': 'Quantification of RNA degradation of blood-specific markers to indicate the age of bloodstains',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2017.09.175',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Genetic characterization of 27 Y-STR loci with the Yfiler® Plus kit in the population of Serbia',
        'Research Title AR': 'Genetic characterization of 27 Y-STR loci with the Yfiler® Plus kit in the population of Serbia',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.fsigen.2017.07.013',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'DNA analysis from human skeletal remains in forensic casework',
        'Research Title AR': 'DNA analysis from human skeletal remains in forensic casework',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2017.09.117',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Rapidly mutating Y-STRs population data in the population of Serbia and haplotype probability assessment for forensic purposes',
        'Research Title AR': 'Rapidly mutating Y-STRs population data in the population of Serbia and haplotype probability assessment for forensic purposes',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2017.09.169',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Rapidly mutating Y-STRs population data in the population of Serbia and haplotype probability assessment for forensic purposes',
        'Research Title AR': 'Rapidly mutating Y-STRs population data in the population of Serbia and haplotype probability assessment for forensic purposes',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2017.09.170',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Mutation rate at 13 rapidly mutating Y-STR loci in the population of Serbia',
        'Research Title AR': 'Mutation rate at 13 rapidly mutating Y-STR loci in the population of Serbia',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2017.09.171',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Y-chromosome polymorphisms in the United Arab Emirates population',
        'Research Title AR': 'Y-chromosome polymorphisms in the United Arab Emirates population',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Forensic DNA Typing: Principles, Applications and Advancements',
        'Journal Label AR': ' Forensic DNA Typing: Principles, Applications and Advancements',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2017.09.163',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Rapidly mutating Y-STR analyses of compromised forensic samples',
        'Research Title AR': 'Rapidly mutating Y-STR analyses of compromised forensic samples',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2013.10.103',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'The Comoros Show the Earliest Austronesian Gene Flow into the Swahili Corridor',
        'Research Title AR': 'The Comoros Show the Earliest Austronesian Gene Flow into the Swahili Corridor',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'The American Journal of Human Genetics',
        'Journal Label AR': 'The American Journal of Human Genetics',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.ajhg.2017.11.011 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Population genetics-informed meta-analysis in seven genes associated with risk to dengue fever disease',
        'Research Title AR': 'Population genetics-informed meta-analysis in seven genes associated with risk to dengue fever disease',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Infection, Genetics and Evolution',
        'Journal Label AR': 'Infection, Genetics and Evolution',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.meegid.2018.04.018 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Noora Al Mutawa',
        'Author Name AR': 'د. نورة المطوع',
        'Research Title EN': 'Investigation of Indecent Images of Children cases: Challenges and suggestions collected from the trenches',
        'Research Title AR': 'Investigation of Indecent Images of Children cases: Challenges and suggestions collected from the trenches',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Digital Investigation',
        'Journal Label AR': 'Digital Investigation',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.diin.2017.11.002',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Lootah',
        'Author Name AR': 'ريم لوتاه ',
        'Research Title EN': 'Allelic and haplotype diversity of 12 X-STRs in the United Arab Emirates',
        'Research Title AR': 'Allelic and haplotype diversity of 12 X-STRs in the United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.fsigen.2017.12.013 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohamed A. Almarri',
        'Author Name AR': 'د. محمد المري',
        'Research Title EN': 'Amino acid residues in five separate HLA genes can explain most of the known associations between the MHC and primary biliary cholangitis',
        'Research Title AR': 'Amino acid residues in five separate HLA genes can explain most of the known associations between the MHC and primary biliary cholangitis',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'PLOS Genetics',
        'Journal Label AR': 'PLOS Genetics',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1371/journal.pgen.1007833 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hamda Sultan Ali Al Obaidly',
        'Author Name AR': 'حمدة سلطان على',
        'Research Title EN': 'Development and validation of fast liquid chromatography high-resolution mass spectrometric (LC-APCI-QToF-MS) methods for the analysis of hexamethylene triperoxide diamine (HMTD) and triacetone triperoxide (TATP)',
        'Research Title AR': 'Development and validation of fast liquid chromatography high-resolution mass spectrometric (LC-APCI-QToF-MS) methods for the analysis of hexamethylene triperoxide diamine (HMTD) and triacetone triperoxide (TATP)',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Chemistry',
        'Journal Label AR': 'Forensic Chemistry',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.forc.2018.06.003',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Genome-Wide Characterization of Arabian Peninsula Populations: Shedding Light on the History of a Fundamental Bridge between Continents',
        'Research Title AR': 'Genome-Wide Characterization of Arabian Peninsula Populations: Shedding Light on the History of a Fundamental Bridge between Continents',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Molecular biology and evolution',
        'Journal Label AR': 'Molecular biology and evolution',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1093/molbev/msz005',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Suaad Alshehhi',
        'Author Name AR': 'د. سعاد الشحي ',
        'Research Title EN': 'Estimating time since deposition using quantification of RNA degradation in body fluid-specific markers',
        'Research Title AR': 'Estimating time since deposition using quantification of RNA degradation in body fluid-specific markers',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2019.02.046 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'STRmix™ collaborative exercise on DNA mixture interpretation',
        'Research Title AR': 'STRmix™ collaborative exercise on DNA mixture interpretation',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.fsigen.2019.01.006',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Evaluation of mitogenome sequence concordance, heteroplasmy detection, and haplogrouping in a worldwide lineage study using the Precision ID mtDNA Whole Genome Panel',
        'Research Title AR': 'Evaluation of mitogenome sequence concordance, heteroplasmy detection, and haplogrouping in a worldwide lineage study using the Precision ID mtDNA Whole Genome Panel',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigen.2019.07.013',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Noora Al Mutawa',
        'Author Name AR': 'د. نورة المطوع',
        'Research Title EN': 'Behavioural Digital Forensics Model: Embedding Behavioural Evidence Analysis into the Investigation of Digital Crimes',
        'Research Title AR': 'Behavioural Digital Forensics Model: Embedding Behavioural Evidence Analysis into the Investigation of Digital Crimes',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Digital Investigation',
        'Journal Label AR': 'Digital Investigation',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.diin.2018.12.003',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed Thani Rashid Almarri',
        'Author Name AR': 'محمد ثاني راشد المري',
        'Research Title EN': 'A complicated murder case solved with the aid of fingerprints',
        'Research Title AR': 'A complicated murder case solved with the aid of fingerprints',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Medico-Legal Update',
        'Journal Label AR': 'Medico-Legal Update',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.37506/mlu.v20i1.390 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulrahman Mohammad AlSuwaidi',
        'Author Name AR': 'عبدالرحمن محمد المهيري',
        'Research Title EN': 'A complicated murder case solved with the aid of fingerprints',
        'Research Title AR': 'A complicated murder case solved with the aid of fingerprints',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Medico-Legal Update',
        'Journal Label AR': 'Medico-Legal Update',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.37506/mlu.v20i1.390 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammad Ahmad AlSuwaidi',
        'Author Name AR': 'محمد احمد السويدي ',
        'Research Title EN': 'A complicated murder case solved with the aid of fingerprints',
        'Research Title AR': 'A complicated murder case solved with the aid of fingerprints',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Medico-Legal Update',
        'Journal Label AR': 'Medico-Legal Update',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.37506/mlu.v20i1.390 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Jassim Mohammed Rashid',
        'Author Name AR': 'جاسم محمد راشد ',
        'Research Title EN': 'A complicated murder case solved with the aid of fingerprints',
        'Research Title AR': 'A complicated murder case solved with the aid of fingerprints',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Medico-Legal Update',
        'Journal Label AR': 'Medico-Legal Update',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.37506/mlu.v20i1.390 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Sheikha Sanqoor',
        'Author Name AR': 'د. شيخة صنقور',
        'Research Title EN': 'Study of insertion-deletion polymorphisms (indels) in the UAE population',
        'Research Title AR': 'Study of insertion-deletion polymorphisms (indels) in the UAE population',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.10.090',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Investigating the resolution of ancestry testing in geographic regions characterized by high population admixture',
        'Research Title AR': 'Investigating the resolution of ancestry testing in geographic regions characterized by high population admixture',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.09.005',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Naima Aljanahi',
        'Author Name AR': 'نعيمة الجناحي ',
        'Research Title EN': 'Forensic evaluation of VeriFiler™ Plus 6-dye chemistry kit composed of 23 loci with casework samples',
        'Research Title AR': 'Forensic evaluation of VeriFiler™ Plus 6-dye chemistry kit composed of 23 loci with casework samples',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.11.012 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Forensic evaluation of VeriFiler™ Plus 6-dye chemistry kit composed of 23 loci with casework samples',
        'Research Title AR': 'Forensic evaluation of VeriFiler™ Plus 6-dye chemistry kit composed of 23 loci with casework samples',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.11.012',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Population genetics data of 23 autosomal STR loci for three Populations in United Arab Emirates',
        'Research Title AR': 'Population genetics data of 23 autosomal STR loci for three Populations in United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.09.073',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Whole mtGenome analysis in United Arab Emirates populations',
        'Research Title AR': 'Whole mtGenome analysis in United Arab Emirates populations',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.10.031',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Evaluation of rapidly mutating Y-STRs in Pakistani population',
        'Research Title AR': 'Evaluation of rapidly mutating Y-STRs in Pakistani population',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.09.094',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Evaluation of rapidly mutating Y-STRs in Pakistani population',
        'Research Title AR': 'Evaluation of rapidly mutating Y-STRs in Pakistani population',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.09.094',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hanan Almulla',
        'Author Name AR': 'حنان الملا',
        'Research Title EN': 'Evaluation of rapidly mutating Y-STRs in Pakistani population',
        'Research Title AR': 'Evaluation of rapidly mutating Y-STRs in Pakistani population',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.09.094',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hussain Alghanim',
        'Author Name AR': 'د. حسين الغانم ',
        'Research Title EN': 'Applications of epigenetic methylation in body fluid identification, age determination and phenotyping',
        'Research Title AR': 'Applications of epigenetic methylation in body fluid identification, age determination and phenotyping',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.10.061 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Investigation on rapidly mutating Y-STRs multiplex in Indian population: A pilot study',
        'Research Title AR': 'Investigation on rapidly mutating Y-STRs multiplex in Indian population: A pilot study',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.10.184',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Investigation on rapidly mutating Y-STRs multiplex in Indian population: A pilot study',
        'Research Title AR': 'Investigation on rapidly mutating Y-STRs multiplex in Indian population: A pilot study',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.10.184',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hamda Alfalasi',
        'Author Name AR': 'حمدة بن تركيه الفلاسي',
        'Research Title EN': 'Investigation on rapidly mutating Y-STRs multiplex in Indian population: A pilot study',
        'Research Title AR': 'Investigation on rapidly mutating Y-STRs multiplex in Indian population: A pilot study',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.10.184',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Evaluation of 13 rapidly mutating Y-STRs on a Dravidian pedigree',
        'Research Title AR': 'Evaluation of 13 rapidly mutating Y-STRs on a Dravidian pedigree',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.09.083',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Forensic and population genetic analysis of Serbian population using 21 STR loci of GlobalFiler™ PCR amplification kit',
        'Research Title AR': 'Forensic and population genetic analysis of Serbian population using 21 STR loci of GlobalFiler™ PCR amplification kit',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.09.020',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'DNA typing from skeletal remains using GlobalFiler™ PCR amplification and Investigator® 24plex QS kits',
        'Research Title AR': 'DNA typing from skeletal remains using GlobalFiler™ PCR amplification and Investigator® 24plex QS kits',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.09.021',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Afrah Almansoori',
        'Author Name AR': 'د. أفراح المنصوري',
        'Research Title EN': 'Suspicious Activity Detection of Twitter and Facebook using Sentimental Analysis',
        'Research Title AR': 'Suspicious Activity Detection of Twitter and Facebook using Sentimental Analysis',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'TEM Journal',
        'Journal Label AR': 'TEM Journal',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.18421/tem94-01 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashid Almansoori',
        'Author Name AR': 'د. راشد المنصوري',
        'Research Title EN': 'Exploring investigative interviewing: A Dubai perspective',
        'Research Title AR': 'Exploring investigative interviewing: A Dubai perspective',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Law, Crime and Justice',
        'Journal Label AR': 'International Journal of Law, Crime and Justice',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.ijlcj.2020.100393 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Mobile phones represent a pathway for microbial transmission: A scoping review',
        'Research Title AR': 'Mobile phones represent a pathway for microbial transmission: A scoping review',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Travel medicine and infectious disease',
        'Journal Label AR': 'Travel medicine and infectious disease',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.tmaid.2020.101704',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Suaad Alshehhi',
        'Author Name AR': 'د. سعاد الشحي ',
        'Research Title EN': 'Evaluating the effect of body fluid mixture on the relative expression ratio of blood-specific RNA markers',
        'Research Title AR': 'Evaluating the effect of body fluid mixture on the relative expression ratio of blood-specific RNA markers',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2019.110116 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Y Chromosome Short Tandem Repeats Typing',
        'Research Title AR': 'Y Chromosome Short Tandem Repeats Typing',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Forensic DNA Typing: Principles, Applications and Advancements',
        'Journal Label AR': ' Forensic DNA Typing: Principles, Applications and Advancements',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1007/978-981-15-6655-4_14',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed Thani Rashid Almarri',
        'Author Name AR': 'محمد ثاني راشد المري',
        'Research Title EN': 'Significance of Fingerprints in A Brutal Travel Bag Murder- A Case Report',
        'Research Title AR': 'Significance of Fingerprints in A Brutal Travel Bag Murder- A Case Report',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Medico-Legal Update',
        'Journal Label AR': 'Medico-Legal Update',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.37506/mlu.v20i1.390',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'A pilot metagenomic study reveals that community derived mobile phones are reservoirs of viable pathogenic microbes',
        'Research Title AR': 'A pilot metagenomic study reveals that community derived mobile phones are reservoirs of viable pathogenic microbes',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Scientific reports',
        'Journal Label AR': ' Scientific reports',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1038/s41598-021-93622-w',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulla Albastaki',
        'Author Name AR': 'عبدالله البستكي ',
        'Research Title EN': 'A pilot metagenomic study reveals that community derived mobile phones are reservoirs of viable pathogenic microbes',
        'Research Title AR': 'A pilot metagenomic study reveals that community derived mobile phones are reservoirs of viable pathogenic microbes',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Scientific reports',
        'Journal Label AR': ' Scientific reports',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1038/s41598-021-93622-w',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Fuad Ali Tarbah',
        'Author Name AR': 'د. فؤاد تربح',
        'Research Title EN': 'Designer benzodiazepines versus prescription benzodiazepines: can structural relation predict the next step?',
        'Research Title AR': 'Designer benzodiazepines versus prescription benzodiazepines: can structural relation predict the next step?',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Critical reviews in toxicology',
        'Journal Label AR': 'Critical reviews in toxicology',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1080/10408444.2021.1907303',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Mobile phones of paediatric hospital staff are never cleaned and commonly used in toilets with implications for healthcare nosocomial diseases',
        'Research Title AR': 'Mobile phones of paediatric hospital staff are never cleaned and commonly used in toilets with implications for healthcare nosocomial diseases',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Scientific reports',
        'Journal Label AR': ' Scientific reports',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1038/s41598-021-92360-3',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammad Al Khloofi',
        'Author Name AR': 'محمد الخلوفي',
        'Research Title EN': 'Forensic entomology when the evidence is “no insect.” Best carrion fly species for predicting maximum postmortem interval in the United Arab Emirates',
        'Research Title AR': 'Forensic entomology when the evidence is “no insect.” Best carrion fly species for predicting maximum postmortem interval in the United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2021.110999 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Forensic entomology when the evidence is “no insect.” Best carrion fly species for predicting maximum postmortem interval in the United Arab Emirates',
        'Research Title AR': 'Forensic entomology when the evidence is “no insect.” Best carrion fly species for predicting maximum postmortem interval in the United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2021.110999 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mariam Sajwani',
        'Author Name AR': 'مريم سجواني',
        'Research Title EN': 'Forensic entomology when the evidence is “no insect.” Best carrion fly species for predicting maximum postmortem interval in the United Arab Emirates',
        'Research Title AR': 'Forensic entomology when the evidence is “no insect.” Best carrion fly species for predicting maximum postmortem interval in the United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2021.110999 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Maryam Al Maidoor',
        'Author Name AR': 'مريم الميدور ',
        'Research Title EN': 'Forensic entomology when the evidence is “no insect.” Best carrion fly species for predicting maximum postmortem interval in the United Arab Emirates',
        'Research Title AR': 'Forensic entomology when the evidence is “no insect.” Best carrion fly species for predicting maximum postmortem interval in the United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2021.110999 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rawdha Al Shamsi',
        'Author Name AR': 'د. روضة الشامسي',
        'Research Title EN': 'Forensic entomology when the evidence is “no insect.” Best carrion fly species for predicting maximum postmortem interval in the United Arab Emirates',
        'Research Title AR': 'Forensic entomology when the evidence is “no insect.” Best carrion fly species for predicting maximum postmortem interval in the United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2021.110999 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': ' Hamdan Ahli',
        'Author Name AR': 'حمدان أهلي',
        'Research Title EN': 'Forensic entomology when the evidence is “no insect.” Best carrion fly species for predicting maximum postmortem interval in the United Arab Emirates',
        'Research Title AR': 'Forensic entomology when the evidence is “no insect.” Best carrion fly species for predicting maximum postmortem interval in the United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2021.110999 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ashwaq Saeed',
        'Author Name AR': 'أشواق سعيد ',
        'Research Title EN': 'Forensic entomology when the evidence is “no insect.” Best carrion fly species for predicting maximum postmortem interval in the United Arab Emirates',
        'Research Title AR': 'Forensic entomology when the evidence is “no insect.” Best carrion fly species for predicting maximum postmortem interval in the United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2021.110999 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohamed A. Almarri',
        'Author Name AR': 'د. محمد المري',
        'Research Title EN': 'The genomic history of the Middle East',
        'Research Title AR': 'The genomic history of the Middle East',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Cell',
        'Journal Label AR': 'Cell',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.cell.2021.07.013',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Lootah',
        'Author Name AR': 'ريم لوتاه ',
        'Research Title EN': 'The genomic history of the Middle East',
        'Research Title AR': 'The genomic history of the Middle East',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Cell',
        'Journal Label AR': 'Cell',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.cell.2021.07.013',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Projecting Ancient Ancestry in Modern-Day Arabians and Iranians: A Key Role of the Past Exposed Arabo-Persian Gulf on Human Migrations',
        'Research Title AR': 'Projecting Ancient Ancestry in Modern-Day Arabians and Iranians: A Key Role of the Past Exposed Arabo-Persian Gulf on Human Migrations',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Genome biology and evolution',
        'Journal Label AR': 'Genome biology and evolution',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1093/gbe/evab194',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'First confirmed detection of SARS-COV-2 in untreated municipal and aircraft wastewater in Dubai, UAE: The use of wastewater based epidemiology as an early warning tool to monitor the prevalence of COVID-19',
        'Research Title AR': 'First confirmed detection of SARS-COV-2 in untreated municipal and aircraft wastewater in Dubai, UAE: The use of wastewater based epidemiology as an early warning tool to monitor the prevalence of COVID-19',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Science of the total Enviroment',
        'Journal Label AR': 'Science of the total Enviroment',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.scitotenv.2020.143350',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulla Albastaki',
        'Author Name AR': 'عبدالله البستكي ',
        'Research Title EN': 'First confirmed detection of SARS-COV-2 in untreated municipal and aircraft wastewater in Dubai, UAE: The use of wastewater based epidemiology as an early warning tool to monitor the prevalence of COVID-19',
        'Research Title AR': 'First confirmed detection of SARS-COV-2 in untreated municipal and aircraft wastewater in Dubai, UAE: The use of wastewater based epidemiology as an early warning tool to monitor the prevalence of COVID-19',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Science of the total Enviroment',
        'Journal Label AR': 'Science of the total Enviroment',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.scitotenv.2020.143350',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Design and development of novel single multiplex system incorporating 26 rapidly mutating Y-STRs; 26 RM Yplex',
        'Research Title AR': 'Design and development of novel single multiplex system incorporating 26 rapidly mutating Y-STRs; 26 RM Yplex',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Electrophoresis',
        'Journal Label AR': ' Electrophoresis',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1002/elps.202200099',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohamed A. Almarri',
        'Author Name AR': 'د. محمد المري',
        'Research Title EN': 'Demonstrating trustworthiness when collecting and sharing genomic data: public views across 22 countries',
        'Research Title AR': 'Demonstrating trustworthiness when collecting and sharing genomic data: public views across 22 countries',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Genome Medicine',
        'Journal Label AR': 'Genome Medicine',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1186/s13073-021-00903-0 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'The role of mobile phones as a possible pathway for pathogen movement A cross-sectional, microbial analysis',
        'Research Title AR': 'The role of mobile phones as a possible pathway for pathogen movement A cross-sectional, microbial analysis',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Travel medicine and infectious disease',
        'Journal Label AR': ' Travel medicine and infectious disease',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.tmaid.2021.102095',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Forensic features and genetic legacy of the Baloch population of Pakistan and the Hazara population across Durand line revealed by Y-chromosomal STRs',
        'Research Title AR': 'Forensic features and genetic legacy of the Baloch population of Pakistan and the Hazara population across Durand line revealed by Y-chromosomal STRs',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' International journal of legal medicine',
        'Journal Label AR': ' International journal of legal medicine',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1007/s00414-021-02591-2',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Enas Awad Abd Elazeem',
        'Author Name AR': 'إيناس عوض ',
        'Research Title EN': 'Estimation of postmortem interval in myocardial stab wounds and firearm injuries: An immunohistochemical comparative study using C5b-9 and cardiac Troponin C',
        'Research Title AR': 'Estimation of postmortem interval in myocardial stab wounds and firearm injuries: An immunohistochemical comparative study using C5b-9 and cardiac Troponin C',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2021.110846 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Younis Albalooshi',
        'Author Name AR': 'د. يونس البلوشي',
        'Research Title EN': 'Fatal automobile accident due to airbag misdeployment',
        'Research Title AR': 'Fatal automobile accident due to airbag misdeployment',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International journal of legal medicine',
        'Journal Label AR': 'International journal of legal medicine',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1007/s00414-020-02457-z',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Design and development of novel single multiplex system incorporating 26 rapidly mutating Y-STRs; 26 RM Yplex',
        'Research Title AR': 'Design and development of novel single multiplex system incorporating 26 rapidly mutating Y-STRs; 26 RM Yplex',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Electrophoresis',
        'Journal Label AR': ' Electrophoresis',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1002/elps.202200099',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulla Albastaki',
        'Author Name AR': 'عبدالله البستكي ',
        'Research Title EN': 'Design and development of novel single multiplex system incorporating 26 rapidly mutating Y-STRs; 26 RM Yplex',
        'Research Title AR': 'Design and development of novel single multiplex system incorporating 26 rapidly mutating Y-STRs; 26 RM Yplex',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Electrophoresis',
        'Journal Label AR': ' Electrophoresis',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1002/elps.202200099',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Characterization of Arabian Peninsula whole exomes: Contributing to the catalogue of human diversity',
        'Research Title AR': 'Characterization of Arabian Peninsula whole exomes: Contributing to the catalogue of human diversity',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' iScience',
        'Journal Label AR': ' iScience',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.isci.2022.105336 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohamed A. Almarri',
        'Author Name AR': 'د. محمد المري',
        'Research Title EN': 'Return of genomic results does not motivate intent to participate in research for all: Perspectives across 22 countries',
        'Research Title AR': 'Return of genomic results does not motivate intent to participate in research for all: Perspectives across 22 countries',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Genetics in Medicine',
        'Journal Label AR': 'Genetics in Medicine',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.gim.2022.01.002 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Eman Saeed Almazrouei ',
        'Author Name AR': 'إيمان المزروعي',
        'Research Title EN': 'The identification of drugs of abuse in E-cigarette samples seized in Dubai between 2016 and 2020.',
        'Research Title AR': 'The identification of drugs of abuse in E-cigarette samples seized in Dubai between 2016 and 2020.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2022.111233',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': ' Dr. Rashed Humaid Alremeithi',
        'Author Name AR': 'د. راشد حميد الرميثي',
        'Research Title EN': 'Forensic Analysis of Textile Synthetic Fibers Using a FT-IR Spectroscopy Approach.',
        'Research Title AR': 'Forensic Analysis of Textile Synthetic Fibers Using a FT-IR Spectroscopy Approach.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Molecules (Basel, Switzerland)',
        'Journal Label AR': ' Molecules (Basel, Switzerland)',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/molecules27134281',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': ' Dr. Rashed Humaid Alremeithi',
        'Author Name AR': 'د. راشد حميد الرميثي',
        'Research Title EN': 'Pocket-size near-IR spectrometers for rapid examination of contaminated textile fibres at the crime-scene',
        'Research Title AR': 'Pocket-size near-IR spectrometers for rapid examination of contaminated textile fibres at the crime-scene',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Vibrational Spectroscopy',
        'Journal Label AR': 'Vibrational Spectroscopy',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': ' 10.1016/j.vibspec.2022.103464',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Fatma Altamimi',
        'Author Name AR': 'فاطمة التميمي',
        'Research Title EN': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods: Automate Express™ & Hamilton Microlab STAR™ System',
        'Research Title AR': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods: Automate Express™ & Hamilton Microlab STAR™ System',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': ' Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yskr7711',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Afra Naqib Sanqoor',
        'Author Name AR': 'عفراء صنقور',
        'Research Title EN': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods: Automate Express™ & Hamilton Microlab STAR™ System',
        'Research Title AR': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods: Automate Express™ & Hamilton Microlab STAR™ System',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': ' Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yskr7712',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Naima Aljanahi',
        'Author Name AR': 'نعيمة الجناحي',
        'Research Title EN': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods: Automate Express™ & Hamilton Microlab STAR™ System',
        'Research Title AR': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods: Automate Express™ & Hamilton Microlab STAR™ System',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': ' Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yskr7713',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods: Automate Express™ & Hamilton Microlab STAR™ System',
        'Research Title AR': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods: Automate Express™ & Hamilton Microlab STAR™ System',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': ' Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yskr7714',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hanan Almulla',
        'Author Name AR': 'حنان الملا',
        'Research Title EN': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods: Automate Express™ & Hamilton Microlab STAR™ System',
        'Research Title AR': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods: Automate Express™ & Hamilton Microlab STAR™ System',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': ' Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yskr7715',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Sheikha Sanqoor',
        'Author Name AR': 'د. شيخة صنقور',
        'Research Title EN': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods: Automate Express™ & Hamilton Microlab STAR™ System',
        'Research Title AR': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods: Automate Express™ & Hamilton Microlab STAR™ System',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': ' Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yskr7716',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hussain Alghanim',
        'Author Name AR': 'د. حسين الغانم ',
        'Research Title EN': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods: Automate Express™ & Hamilton Microlab STAR™ System',
        'Research Title AR': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods: Automate Express™ & Hamilton Microlab STAR™ System',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': ' Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yskr7717',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed Alrahma',
        'Author Name AR': 'محمد ال رحمه ',
        'Research Title EN': 'Performance of Different Cotton and Nylon Swabs on DNA Recovery and Storage',
        'Research Title AR': 'Performance of Different Cotton and Nylon Swabs on DNA Recovery and Storage',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yqmy9190',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hanan Almulla',
        'Author Name AR': 'حنان الملا',
        'Research Title EN': 'Performance of Different Cotton and Nylon Swabs on DNA Recovery and Storage',
        'Research Title AR': 'Performance of Different Cotton and Nylon Swabs on DNA Recovery and Storage',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yqmy9190',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Suaad Alshehhi',
        'Author Name AR': 'د. سعاد الشحي ',
        'Research Title EN': 'Performance of Different Cotton and Nylon Swabs on DNA Recovery and Storage',
        'Research Title AR': 'Performance of Different Cotton and Nylon Swabs on DNA Recovery and Storage',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yqmy9190',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Performance of Different Cotton and Nylon Swabs on DNA Recovery and Storage',
        'Research Title AR': 'Performance of Different Cotton and Nylon Swabs on DNA Recovery and Storage',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yqmy9190',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Naima Aljanahi',
        'Author Name AR': 'نعيمة الجناحي',
        'Research Title EN': 'Performance of Different Cotton and Nylon Swabs on DNA Recovery and Storage',
        'Research Title AR': 'Performance of Different Cotton and Nylon Swabs on DNA Recovery and Storage',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yqmy9190',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hussain Alghanim',
        'Author Name AR': 'د. حسين الغانم ',
        'Research Title EN': 'Performance of Different Cotton and Nylon Swabs on DNA Recovery and Storage',
        'Research Title AR': 'Performance of Different Cotton and Nylon Swabs on DNA Recovery and Storage',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yqmy9190',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ayesha Alsabhan',
        'Author Name AR': 'عائشة السبهان',
        'Research Title EN': 'Performance of Different Cotton and Nylon Swabs on DNA Recovery and Storage',
        'Research Title AR': 'Performance of Different Cotton and Nylon Swabs on DNA Recovery and Storage',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yqmy9190',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Do mobile phone surfaces carry SARS-CoV-2 virus? A systematic review warranting the inclusion of a “6th” moment of hand hygiene in healthcare',
        'Research Title AR': 'Do mobile phone surfaces carry SARS-CoV-2 virus? A systematic review warranting the inclusion of a “6th” moment of hand hygiene in healthcare',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of infection and public health',
        'Journal Label AR': 'Journal of infection and public health',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.jiph.2023.08.017 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulla Albastaki',
        'Author Name AR': 'عبدالله البستكي ',
        'Research Title EN': 'Do mobile phone surfaces carry SARS-CoV-2 virus? A systematic review warranting the inclusion of a “6th” moment of hand hygiene in healthcare',
        'Research Title AR': 'Do mobile phone surfaces carry SARS-CoV-2 virus? A systematic review warranting the inclusion of a “6th” moment of hand hygiene in healthcare',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of infection and public health',
        'Journal Label AR': 'Journal of infection and public health',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.jiph.2023.08.017 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Do mobile phone surfaces carry SARS-CoV-2 virus? A systematic review warranting the inclusion of a “6th” moment of hand hygiene in healthcare',
        'Research Title AR': 'Do mobile phone surfaces carry SARS-CoV-2 virus? A systematic review warranting the inclusion of a “6th” moment of hand hygiene in healthcare',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of infection and public health',
        'Journal Label AR': 'Journal of infection and public health',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.jiph.2023.08.017 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Sumaya Almansoori',
        'Author Name AR': 'د. سمية المنصوري',
        'Research Title EN': 'Do mobile phone surfaces carry SARS-CoV-2 virus? A systematic review warranting the inclusion of a “6th” moment of hand hygiene in healthcare',
        'Research Title AR': 'Do mobile phone surfaces carry SARS-CoV-2 virus? A systematic review warranting the inclusion of a “6th” moment of hand hygiene in healthcare',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of infection and public health',
        'Journal Label AR': 'Journal of infection and public health',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.jiph.2023.08.017 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hussain Al Marzooqi',
        'Author Name AR': 'حسين على محمد المرزوقي',
        'Research Title EN': 'Do mobile phone surfaces carry SARS-CoV-2 virus? A systematic review warranting the inclusion of a “6th” moment of hand hygiene in healthcare',
        'Research Title AR': 'Do mobile phone surfaces carry SARS-CoV-2 virus? A systematic review warranting the inclusion of a “6th” moment of hand hygiene in healthcare',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of infection and public health',
        'Journal Label AR': 'Journal of infection and public health',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.jiph.2023.08.017 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Mobile phones as fomites for pathogenic microbes: A cross-sectional survey of perceptions and sanitization habits of health care workers in Dubai, United Arab Emirates',
        'Research Title AR': 'Mobile phones as fomites for pathogenic microbes: A cross-sectional survey of perceptions and sanitization habits of health care workers in Dubai, United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Infection, disease & health',
        'Journal Label AR': 'Infection, disease & health',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.idh.2022.07.001',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Mobile phones as fomites for pathogenic microbes: A cross-sectional survey of perceptions and sanitization habits of health care workers in Dubai, United Arab Emirates',
        'Research Title AR': 'Mobile phones as fomites for pathogenic microbes: A cross-sectional survey of perceptions and sanitization habits of health care workers in Dubai, United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Infection, disease & health',
        'Journal Label AR': 'Infection, disease & health',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.idh.2022.07.001',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hanan Almulla',
        'Author Name AR': 'حنان الملا',
        'Research Title EN': 'Mobile phones as fomites for pathogenic microbes: A cross-sectional survey of perceptions and sanitization habits of health care workers in Dubai, United Arab Emirates',
        'Research Title AR': 'Mobile phones as fomites for pathogenic microbes: A cross-sectional survey of perceptions and sanitization habits of health care workers in Dubai, United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Infection, disease & health',
        'Journal Label AR': 'Infection, disease & health',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.idh.2022.07.001',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulla Albastaki',
        'Author Name AR': 'عبدالله البستكي ',
        'Research Title EN': 'Mobile phones as fomites for pathogenic microbes: A cross-sectional survey of perceptions and sanitization habits of health care workers in Dubai, United Arab Emirates',
        'Research Title AR': 'Mobile phones as fomites for pathogenic microbes: A cross-sectional survey of perceptions and sanitization habits of health care workers in Dubai, United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Infection, disease & health',
        'Journal Label AR': ' Infection, disease & health',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.idh.2022.07.001',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mohamad J. Altamimi',
        'Author Name AR': 'د. محمد جمال التميمي',
        'Research Title EN': 'Digital forensic intelligence for illicit drug analysis in forensic investigations',
        'Research Title AR': 'Digital forensic intelligence for illicit drug analysis in forensic investigations',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' iScience',
        'Journal Label AR': ' iScience',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.isci.2023.108023',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Afrah Almansoori',
        'Author Name AR': 'د. أفراح المنصوري',
        'Research Title EN': 'Exploring the Frontiers of Cybersecurity Behavior: A Systematic Review of Studies and Theories',
        'Research Title AR': 'Exploring the Frontiers of Cybersecurity Behavior: A Systematic Review of Studies and Theories',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Applied Sciences',
        'Journal Label AR': 'Applied Sciences',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.3390/app13095700',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Microsatellites’ mutation modeling through the analysis of the Y-chromosomal transmission: Results of a GHEP-ISFG collaborative study',
        'Research Title AR': 'Microsatellites’ mutation modeling through the analysis of the Y-chromosomal transmission: Results of a GHEP-ISFG collaborative study',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.1016/j.fsigen.2023.102999 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Microsatellites’ mutation modeling through the analysis of the Y-chromosomal transmission: Results of a GHEP-ISFG collaborative study',
        'Research Title AR': 'Microsatellites’ mutation modeling through the analysis of the Y-chromosomal transmission: Results of a GHEP-ISFG collaborative study',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.1016/j.fsigen.2023.102999 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Rowdha Abdulla Alblooshi',
        'Author Name AR': 'روضة البلوشي',
        'Research Title EN': 'Comparative forensic discrimination of pink lipsticks using fourier transform infra-red and Raman spectroscopy',
        'Research Title AR': 'Comparative forensic discrimination of pink lipsticks using fourier transform infra-red and Raman spectroscopy',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Vibrational Spectroscopy',
        'Journal Label AR': 'Vibrational Spectroscopy',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.1016/j.vibspec.2023.103640 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': ' Dr. Rashed Humaid Alremeithi',
        'Author Name AR': 'د. راشد حميد الرميثي',
        'Research Title EN': 'Comparative forensic discrimination of pink lipsticks using fourier transform infra-red and Raman spectroscopy',
        'Research Title AR': 'Comparative forensic discrimination of pink lipsticks using fourier transform infra-red and Raman spectroscopy',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Vibrational Spectroscopy',
        'Journal Label AR': 'Vibrational Spectroscopy',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.1016/j.vibspec.2023.103640 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulrahman Hussain Aljannahi',
        'Author Name AR': 'عبدالرحمن الجناحي',
        'Research Title EN': 'Comparative forensic discrimination of pink lipsticks using fourier transform infra-red and Raman spectroscopy',
        'Research Title AR': 'Comparative forensic discrimination of pink lipsticks using fourier transform infra-red and Raman spectroscopy',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Vibrational Spectroscopy',
        'Journal Label AR': 'Vibrational Spectroscopy',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.1016/j.vibspec.2023.103640 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohamed A. Almarri',
        'Author Name AR': 'د. محمد المري',
        'Research Title EN': 'Ancient genomes illuminate Eastern Arabian population history and adaptation against malaria',
        'Research Title AR': 'Ancient genomes illuminate Eastern Arabian population history and adaptation against malaria',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Cell',
        'Journal Label AR': 'Cell',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.1101/2023.10.01.559299',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Aysha Ali Tamim',
        'Author Name AR': 'عائشة علي بن تميم',
        'Research Title EN': 'Using DNA Barcoding to Detect Adulteration in Different Herbal Plant- Based Products in the United Arab Emirates: Proof of Concept and Validation',
        'Research Title AR': 'Using DNA Barcoding to Detect Adulteration in Different Herbal Plant- Based Products in the United Arab Emirates: Proof of Concept and Validation',
        'Department EN': 'General Department of Administrative Affairs',
        'Department AR': 'الإدارة العامة للشؤون الإدارية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Recent Patents on Food, Nutrition &amp; Agriculture',
        'Journal Label AR': 'Recent Patents on Food, Nutrition &amp; Agriculture',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.2174/2212798410666180409101714',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Aisha Ali Bintamim',
        'Author Name AR': 'عائشة علي بن تميم',
        'Research Title EN': 'The Identification of Drugs of Abuse in E-Cigarette Samples Seized in Dubai Between 2016-2020',
        'Research Title AR': 'The Identification of Drugs of Abuse in E-Cigarette Samples Seized in Dubai Between 2016-2020',
        'Department EN': 'General Department of Administrative Affairs',
        'Department AR': 'الإدارة العامة للشؤون الإدارية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2022.111233',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salem Humaid Alsuwaidi',
        'Author Name AR': 'سالم حميد سالم خليفة السويدي',
        'Research Title EN': 'Airflowing as an adjunctive treatment for periodontitis: A randomized controlled trial',
        'Research Title AR': 'Airflowing as an adjunctive treatment for periodontitis: A randomized controlled trial',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of Periodontology',
        'Journal Label AR': 'Journal of Periodontology',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.1002/jper.24-0099 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Eman Alsayegh',
        'Author Name AR': 'ايمان محمد الصايغ',
        'Research Title EN': 'Maxillary Expansion: A Comparison of Damon Self-Ligating Bracket Therapy with MARPE and PAOO',
        'Research Title AR': 'Maxillary Expansion: A Comparison of Damon Self-Ligating Bracket Therapy with MARPE and PAOO',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'BioMed Research International',
        'Journal Label AR': 'BioMed Research International',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1155/2022/1974467 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulrahman Aljannahi',
        'Author Name AR': 'عبدالرحمن حسين الجناحي',
        'Research Title EN': 'Comparative forensic discrimination of pink lipsticks using fourier transform infra-red and Raman spectroscopy',
        'Research Title AR': 'Comparative forensic discrimination of pink lipsticks using fourier transform infra-red and Raman spectroscopy',
        'Department EN': 'General Department of Organization Protective Security and Emergency',
        'Department AR': 'الإدارة العامة لأمن الهيئات و المنشآت والطواري',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Vibrational Spectroscopy',
        'Journal Label AR': 'Vibrational Spectroscopy',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.1016/j.vibspec.2023.103640 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Subhasis Karmakar',
        'Author Name AR': 'Subhasis Karmakar',
        'Research Title EN': 'Rehabilitation for lumbar pain: A comprehensive review on addressing pain and enhancing function in both acute and chronic situations',
        'Research Title AR': 'Rehabilitation for lumbar pain: A comprehensive review on addressing pain and enhancing function in both acute and chronic situations',
        'Department EN': 'General Department of Administrative Affairs',
        'Department AR': 'الإدارة العامة للشؤون الإدارية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Southeast Asian Journal of Health Professional',
        'Journal Label AR': 'Southeast Asian Journal of Health Professional',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.18231/j.sajhp.2024.002 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Subhasis Karmakar',
        'Author Name AR': 'Subhasis Karmakar',
        'Research Title EN': 'Efficiency of rehabilitation in limb asymmetries of achilles tendinopathy female patients',
        'Research Title AR': 'Efficiency of rehabilitation in limb asymmetries of achilles tendinopathy female patients',
        'Department EN': 'General Department of Administrative Affairs',
        'Department AR': 'الإدارة العامة للشؤون الإدارية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Preventive Medicine and Holistic Health',
        'Journal Label AR': 'Preventive Medicine and Holistic Health',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.18231/j.jpmhh.2023.006 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Subhasis Karmakar',
        'Author Name AR': 'Subhasis Karmakar',
        'Research Title EN': 'Importance of performance appraisal: A short communication',
        'Research Title AR': 'Importance of performance appraisal: A short communication',
        'Department EN': 'General Department of Administrative Affairs',
        'Department AR': 'الإدارة العامة للشؤون الإدارية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of Management Research and Analysis',
        'Journal Label AR': 'Journal of Management Research and Analysis',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.18231/j.jmra.2022.044 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Subhasis Karmakar',
        'Author Name AR': 'Subhasis Karmakar',
        'Research Title EN': 'Pay for performance: A major role to motivate the employees within an organization',
        'Research Title AR': 'Pay for performance: A major role to motivate the employees within an organization',
        'Department EN': 'General Department of Administrative Affairs',
        'Department AR': 'الإدارة العامة للشؤون الإدارية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of Management Research and Analysis',
        'Journal Label AR': 'Journal of Management Research and Analysis',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.18231/j.jmra.2022.043 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Subhasis Karmakar',
        'Author Name AR': 'Subhasis Karmakar',
        'Research Title EN': 'Role of virtual reality technology and robotic rehabilitation in post stroke rehabilitation: Short review',
        'Research Title AR': 'Role of virtual reality technology and robotic rehabilitation in post stroke rehabilitation: Short review',
        'Department EN': 'General Department of Administrative Affairs',
        'Department AR': 'الإدارة العامة للشؤون الإدارية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'IP Indian Journal of Neurosciences',
        'Journal Label AR': 'IP Indian Journal of Neurosciences',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.18231/j.ijn.2022.002 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Subhasis Karmakar',
        'Author Name AR': 'Subhasis Karmakar',
        'Research Title EN': 'Effectiveness of Yoga Sessions and Muscle Stretching in Pain Perception in Software Engineers',
        'Research Title AR': 'Effectiveness of Yoga Sessions and Muscle Stretching in Pain Perception in Software Engineers',
        'Department EN': 'General Department of Administrative Affairs',
        'Department AR': 'الإدارة العامة للشؤون الإدارية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Developments in Anaesthetics & Pain Management',
        'Journal Label AR': 'Developments in Anaesthetics & Pain Management',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.31031/DAPM.2021.02.000532',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Subhasis Karmakar',
        'Author Name AR': 'Subhasis Karmakar',
        'Research Title EN': 'Effectiveness of Scapular Stabilization Exercises in Preventing Upper Limb Injuries in Overhead Athletes',
        'Research Title AR': 'Effectiveness of Scapular Stabilization Exercises in Preventing Upper Limb Injuries in Overhead Athletes',
        'Department EN': 'General Department of Administrative Affairs',
        'Department AR': 'الإدارة العامة للشؤون الإدارية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Orthopedic Research Online Journal',
        'Journal Label AR': 'Orthopedic Research Online Journal',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.31031/OPROJ.2021.08.000686',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Subhasis Karmakar',
        'Author Name AR': 'Subhasis Karmakar',
        'Research Title EN': 'Importance to Train Scapular Muscles to Avoid Scapular Dyskinesia in Athletes',
        'Research Title AR': 'Importance to Train Scapular Muscles to Avoid Scapular Dyskinesia in Athletes',
        'Department EN': 'General Department of Administrative Affairs',
        'Department AR': 'الإدارة العامة للشؤون الإدارية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Research &amp; Investigations in Sports Medicine',
        'Journal Label AR': 'Research &amp; Investigations in Sports Medicine',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.31031/rism.2021.07.000662 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Subhasis Karmakar',
        'Author Name AR': 'Subhasis Karmakar',
        'Research Title EN': 'Motor Control Exercises for Software Employees for their Non-Specific Neck Pain',
        'Research Title AR': 'Motor Control Exercises for Software Employees for their Non-Specific Neck Pain',
        'Department EN': 'General Department of Administrative Affairs',
        'Department AR': 'الإدارة العامة للشؤون الإدارية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Developments in Anaesthetics & Pain Management',
        'Journal Label AR': 'Developments in Anaesthetics & Pain Management',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.31031/DAPM.2020.01.000525',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed Ali Qassim',
        'Author Name AR': 'محمد على القاسم',
        'Research Title EN': 'Nondestructive Handheld Fourier Transform Infrared (FT-IR) Analysis of Spectroscopic Changes and Multivariate Modeling of Thermally Degraded Plain Portland Cement Concrete and its Slag and Fly Ash-Based Analogs',
        'Research Title AR': 'Nondestructive Handheld Fourier Transform Infrared (FT-IR) Analysis of Spectroscopic Changes and Multivariate Modeling of Thermally Degraded Plain Portland Cement Concrete and its Slag and Fly Ash-Based Analogs',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Applied Spectroscopy',
        'Journal Label AR': 'Applied Spectroscopy',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1177/0003702816638306 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Nosrat Mohammad Fouladi',
        'Author Name AR': 'نصرت محمد فولادي',
        'Research Title EN': 'Impact of Compensation Strategies on Employees Satisfaction Case Study in the A. S. XYZ Organization',
        'Research Title AR': 'Impact of Compensation Strategies on Employees Satisfaction Case Study in the A. S. XYZ Organization',
        'Department EN': 'General Department of Airports Security',
        'Department AR': 'الإدارة العامة لأمن المطارات',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of Human Resource and Leadership',
        'Journal Label AR': 'Journal of Human Resource and Leadership',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.47604/jhrl.2561 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulla Hussain Abdulla',
        'Author Name AR': 'عبدالله حسين عبدالله',
        'Research Title EN': 'أثر القيادة الرؤيوية في ادارة الازمات شركة امكو لمقاولات البناء ذ.م.م',
        'Research Title AR': 'أثر القيادة الرؤيوية في ادارة الازمات شركة امكو لمقاولات البناء ذ.م.م',
        'Department EN': 'General Department of Airports Security',
        'Department AR': 'الإدارة العامة لأمن المطارات',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal on Humanities and Social Sciences',
        'Journal Label AR': 'International Journal on Humanities and Social Sciences',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.33193/ijohss.46.2023.580 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Jorge Javier Roman Garate',
        'Author Name AR': 'Jorge Javier Roman Garate',
        'Research Title EN': 'Exploring features and opportunities of rapid-growth wine firms in Chile',
        'Research Title AR': 'Exploring features and opportunities of rapid-growth wine firms in Chile',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Estudios Gerenciales',
        'Journal Label AR': 'Estudios Gerenciales',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.estger.2017.02.004',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'A novel multiplex assay for simultaneously analysing 13 rapidly mutating Y-STRs',
        'Research Title AR': 'A novel multiplex assay for simultaneously analysing 13 rapidly mutating Y-STRs',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2015,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': ' 10.1016/j.fsigen.2015.04.004',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Rapid amplification of the RM-Yplex assay',
        'Research Title AR': 'Rapid amplification of the RM-Yplex assay',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Electrophoresis',
        'Journal Label AR': ' Electrophoresis',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1002/elps.201500549',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Study of 27 Y-STR markers in United Arab Emirates population',
        'Research Title AR': 'Study of 27 Y-STR markers in United Arab Emirates population',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.fsir.2020.100057',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Population data for SE33 locus in United Arab Emirates Arab population',
        'Research Title AR': 'Population data for SE33 locus in United Arab Emirates Arab population',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2015,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2015.09.095',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Reduced volume for direct PCR amplification of blood reference samples using Identifiler® Direct and Globalfiler™ Express assays',
        'Research Title AR': 'Reduced volume for direct PCR amplification of blood reference samples using Identifiler® Direct and Globalfiler™ Express assays',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2017.09.118',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Development and validation of an allelic frequency database for Qatari population using 13 rapidly mutating Y-STRs multiplex assay',
        'Research Title AR': 'Development and validation of an allelic frequency database for Qatari population using 13 rapidly mutating Y-STRs multiplex assay',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2015,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2015.09.145',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'An evaluation of rapidly mutating Y-STR multi-allelic markers',
        'Research Title AR': 'An evaluation of rapidly mutating Y-STR multi-allelic markers',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2015,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2015.10.011',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Whole mtGenome analysis in United Arab Emirates populations',
        'Research Title AR': 'Whole mtGenome analysis in United Arab Emirates populations',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.10.031',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Plastic induced urinary tract disease and dysfunction: a scoping review',
        'Research Title AR': 'Plastic induced urinary tract disease and dysfunction: a scoping review',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' Journal of Exposure Science & Environmental Epidemiology',
        'Journal Label AR': ' Journal of Exposure Science & Environmental Epidemiology',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.1038/s41370-024-00709-3',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'A comparison between Yfiler® and RM Y-STRs in United Arab Emirates population',
        'Research Title AR': 'A comparison between Yfiler® and RM Y-STRs in United Arab Emirates population',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2015,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2015.10.012',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'An evaluation of miniSTR markers for casework applications',
        'Research Title AR': 'An evaluation of miniSTR markers for casework applications',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2015,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2015.09.203',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'An investigation of 21 insertion deletion markers in United Arab Emirates population',
        'Research Title AR': 'An investigation of 21 insertion deletion markers in United Arab Emirates population',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2015,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2015.09.104',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Lootah',
        'Author Name AR': 'ريم لوتاه ',
        'Research Title EN': 'First confirmed detection of SARS-COV-2 in untreated municipal and aircraft wastewater in Dubai, UAE: The use of wastewater based epidemiology as an early warning tool to monitor the prevalence of COVID-19',
        'Research Title AR': 'First confirmed detection of SARS-COV-2 in untreated municipal and aircraft wastewater in Dubai, UAE: The use of wastewater based epidemiology as an early warning tool to monitor the prevalence of COVID-19',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Science of the total Enviroment',
        'Journal Label AR': 'Science of the total Enviroment',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.scitotenv.2020.143350',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Afra Naqib Sanqoor',
        'Author Name AR': 'عفراء صنقور',
        'Research Title EN': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods',
        'Research Title AR': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yskr7711',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Change in frequency pattern in cluster headache induced by subcutaneous sumatriptan.',
        'Research Title AR': 'Change in frequency pattern in cluster headache induced by subcutaneous sumatriptan.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2005,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Headache',
        'Journal Label AR': 'Headache',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1111/j.1526-4610.2005.05195_2.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ahmad AL-TAYER',
        'Author Name AR': 'احمد شعبان الطاير المري',
        'Research Title EN': 'Addressing the Global Climate Change Problem in GATT/WTO Law:',
        'Research Title AR': 'Addressing the Global Climate Change Problem in GATT/WTO Law:',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2011,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'The Journal of World Investment & Trade',
        'Journal Label AR': 'The Journal of World Investment & Trade',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1163/221190011x00012',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Extended Reality Head-Mounted Displays Are Likely to Pose a Significant Risk in Medical Settings While Current Classification Remains as Non-Critical.',
        'Research Title AR': 'Extended Reality Head-Mounted Displays Are Likely to Pose a Significant Risk in Medical Settings While Current Classification Remains as Non-Critical.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Microorganisms',
        'Journal Label AR': 'Microorganisms',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.3390/microorganisms12040815',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulla Ahmed Zaher Omair Juma',
        'Author Name AR': 'عبدالله احمد زاهر عمير ',
        'Research Title EN': 'The impact of transformational leadership on risk management and Dubai police performance',
        'Research Title AR': 'The impact of transformational leadership on risk management and Dubai police performance',
        'Department EN': 'General Department of Organization Protective Security and Emergency',
        'Department AR': 'الإدارة العامة لأمن الهيئات و المنشآت والطواري',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Policing: A Journal of Policy and Practice',
        'Journal Label AR': 'Policing: A Journal of Policy and Practice',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1093/police/paac060',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed Al Blushi',
        'Author Name AR': 'محمد البلوشي',
        'Research Title EN': 'GENIMS – a user-centric and GIS-enabled incident management system',
        'Research Title AR': 'GENIMS – a user-centric and GIS-enabled incident management system',
        'Department EN': 'General Department of Operations',
        'Department AR': 'الإدارة العامة للعمليات',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2010,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Information and Communication Technology',
        'Journal Label AR': 'International Journal of Information and Communication Technology',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1504/ijict.2010.032406',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Afrah Almansoori',
        'Author Name AR': 'عفراء المنصوري',
        'Research Title EN': 'AICV - Internet of Things Impact on the Future of Cyber Crime in 2050.',
        'Research Title AR': 'AICV - Internet of Things Impact on the Future of Cyber Crime in 2050.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Advances in Intelligent Systems and Computing',
        'Journal Label AR': 'Advances in Intelligent Systems and Computing',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1007/978-3-030-76346-6_57',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Cyclic vomiting syndrome: anticipatory stress response in migraine?',
        'Research Title AR': 'Cyclic vomiting syndrome: anticipatory stress response in migraine?',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2004,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Headache',
        'Journal Label AR': 'Headache',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1111/j.1526-4610.2004.t01-2-04020.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Intravenous Magnesium for Neuroprotection in Acute Stroke: Neuropharmacology Supports Clinical Hope. Response',
        'Research Title AR': 'Intravenous Magnesium for Neuroprotection in Acute Stroke: Neuropharmacology Supports Clinical Hope. Response',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2004,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Stroke',
        'Journal Label AR': 'Stroke',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1161/01.str.0000149478.05381.9f',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Menstrual Migraine is Not Pathogenetically Related to Premenstrual Syndrome',
        'Research Title AR': 'Menstrual Migraine is Not Pathogenetically Related to Premenstrual Syndrome',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 1994,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Cephalalgia : an international journal of headache',
        'Journal Label AR': 'Cephalalgia : an international journal of headache',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1046/j.1468-2982.1994.1406411.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'Closing the strategic planning and implementation gap through excellence in the public sector: empirical investigation using SEM',
        'Research Title AR': 'Closing the strategic planning and implementation gap through excellence in the public sector: empirical investigation using SEM',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Measuring Business Excellence',
        'Journal Label AR': 'Measuring Business Excellence',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/mbe-12-2019-0128',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': ' Dr. Rashed Humaid Alremeithi',
        'Author Name AR': 'د. راشد حميد الرميثي',
        'Research Title EN': 'Simultaneous Quantitative Determination of Synthetic Cathinone Enantiomers in Urine and Plasma Using GC-NCI-MS.',
        'Research Title AR': 'Simultaneous Quantitative Determination of Synthetic Cathinone Enantiomers in Urine and Plasma Using GC-NCI-MS.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of analytical methods in chemistry',
        'Journal Label AR': 'Journal of analytical methods in chemistry',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1155/2018/4396043',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulla Albastaki',
        'Author Name AR': 'عبدالله البستكي ',
        'Research Title EN': 'Ultraviolet-C-Based Mobile Phone Sanitisation for Global Public Health and Infection Control.',
        'Research Title AR': 'Ultraviolet-C-Based Mobile Phone Sanitisation for Global Public Health and Infection Control.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Microorganisms',
        'Journal Label AR': 'Microorganisms',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/microorganisms11081876',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Topiramate for migraine prophylaxis: a reappraisal of the therapeutic premise.',
        'Research Title AR': 'Topiramate for migraine prophylaxis: a reappraisal of the therapeutic premise.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2007,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of child neurology',
        'Journal Label AR': 'Journal of child neurology',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1177/0883073807299958',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mohammed Saleh Alosani',
        'Author Name AR': 'الدكتور محمد صالح العوساني',
        'Research Title EN': 'An empirical examination of the relationship between benchmarking, innovation culture and organisational performance using structural equation modelling',
        'Research Title AR': 'An empirical examination of the relationship between benchmarking, innovation culture and organisational performance using structural equation modelling',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'The TQM Journal',
        'Journal Label AR': 'The TQM Journal',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/tqm-02-2020-0034',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'The impact of total quality management and entrepreneurial orientation on organizational performance',
        'Research Title AR': 'The impact of total quality management and entrepreneurial orientation on organizational performance',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Quality & Reliability Management',
        'Journal Label AR': 'International Journal of Quality & Reliability Management',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/ijqrm-03-2014-0034',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hazem Sherif',
        'Author Name AR': 'د. حازم متولى شريف',
        'Research Title EN': 'Fatal automobile accident due to airbag misdeployment',
        'Research Title AR': 'Fatal automobile accident due to airbag misdeployment',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International journal of legal medicine',
        'Journal Label AR': 'International journal of legal medicine',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1007/s00414-020-02457-z',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Meshgan Mohammad Al Awar',
        'Author Name AR': 'مشغان محمد العور',
        'Research Title EN': 'An Unusual Inverted Saline Microbial Mat Community in an Interdune Sabkha in the Rub\' al Khali (the Empty Quarter), United Arab Emirates',
        'Research Title AR': 'An Unusual Inverted Saline Microbial Mat Community in an Interdune Sabkha in the Rub\' al Khali (the Empty Quarter), United Arab Emirates',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'PloS one',
        'Journal Label AR': 'PloS one',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1371/journal.pone.0150342',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'The first modern human dispersals across Africa.',
        'Research Title AR': 'The first modern human dispersals across Africa.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2013,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'PloS one',
        'Journal Label AR': 'PloS one',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1371/journal.pone.0080031',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Recurrent Syncope, Hypotension, Asthma, and Migraine With Aura: Role of Metoclopramide',
        'Research Title AR': 'Recurrent Syncope, Hypotension, Asthma, and Migraine With Aura: Role of Metoclopramide',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2005,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Headache',
        'Journal Label AR': 'Headache',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1111/j.1526-4610.2005.00276_2.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Fawzi Benomran',
        'Author Name AR': 'فوزي عبدالسلام بن عمران',
        'Research Title EN': 'Forensic medicine department of Dubai.',
        'Research Title AR': 'Forensic medicine department of Dubai.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2011,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Legal medicine (Tokyo, Japan)',
        'Journal Label AR': 'Legal medicine (Tokyo, Japan)',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.legalmed.2011.04.005',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Fawzi Benomran',
        'Author Name AR': 'فوزي عبدالسلام بن عمران',
        'Research Title EN': 'Postmortem sole incisions - a new sign of heroin overdose?',
        'Research Title AR': 'Postmortem sole incisions - a new sign of heroin overdose?',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2006,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of forensic and legal medicine',
        'Journal Label AR': 'Journal of forensic and legal medicine',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.jcfm.2006.08.007',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Fawzi Benomran',
        'Author Name AR': 'فوزي عبدالسلام بن عمران',
        'Research Title EN': 'The Global Practice of Forensic Science - Forensic Medicine in the United Arab Emirates',
        'Research Title AR': 'The Global Practice of Forensic Science - Forensic Medicine in the United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2014,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'The Global Practice of Forensic Science',
        'Journal Label AR': 'The Global Practice of Forensic Science',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1002/9781118724248.ch27',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Mutation Rate Analysis of RM Y-STRs in Deep-Rooted Multi-Generational Punjabi Pedigrees from Pakistan.',
        'Research Title AR': 'Mutation Rate Analysis of RM Y-STRs in Deep-Rooted Multi-Generational Punjabi Pedigrees from Pakistan.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Genes',
        'Journal Label AR': 'Genes',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/genes13081403',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Water deprivation headache: \'new\' variants of phenomenology.',
        'Research Title AR': 'Water deprivation headache: \'new\' variants of phenomenology.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2004,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Headache',
        'Journal Label AR': 'Headache',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1111/j.1526-4610.2004.4204_1.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Local population structure in Arabian Peninsula revealed by Y-STR diversity.',
        'Research Title AR': 'Local population structure in Arabian Peninsula revealed by Y-STR diversity.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2009,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Human heredity',
        'Journal Label AR': 'Human heredity',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1159/000210448',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hamad Alawar ',
        'Author Name AR': 'د. حمد العور',
        'Research Title EN': 'The role of Mobile phones as a possible pathway for pathogen movement A CROSS-SECTIONAL, MICROBIAL ANALYSIS',
        'Research Title AR': 'The role of Mobile phones as a possible pathway for pathogen movement A CROSS-SECTIONAL, MICROBIAL ANALYSIS',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Travel medicine and infectious disease',
        'Journal Label AR': 'Travel medicine and infectious disease',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.tmaid.2021.102095',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Recurrent Facial Palsy in Migraine: Mechanistic Considerations',
        'Research Title AR': 'Recurrent Facial Palsy in Migraine: Mechanistic Considerations',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2005,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Headache',
        'Journal Label AR': 'Headache',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1111/j.1526-4610.2005.05056_4.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Metoclopramide aborts cough-induced headache and ameliorates cough--a pilot study.',
        'Research Title AR': 'Metoclopramide aborts cough-induced headache and ameliorates cough--a pilot study.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2006,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International journal of clinical practice',
        'Journal Label AR': 'International journal of clinical practice',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1111/j.1742-1241.2006.00871.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Metoclopramide for migraine-associated hiccup.',
        'Research Title AR': 'Metoclopramide for migraine-associated hiccup.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2006,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International journal of clinical practice',
        'Journal Label AR': 'International journal of clinical practice',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1111/j.1368-5031.2006.00844.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Magnesium for Delayed Cerebral Ischemia in Aneurysmal Subarachnoid Hemorrhage: Time for a Paradigm Shift?',
        'Research Title AR': 'Magnesium for Delayed Cerebral Ischemia in Aneurysmal Subarachnoid Hemorrhage: Time for a Paradigm Shift?',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2005,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Stroke',
        'Journal Label AR': 'Stroke',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1161/01.str.0000183619.90328.6f; 10.1161/01.str.0000190091.36915.84',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Closure of atrial septal defect and migraine.',
        'Research Title AR': 'Closure of atrial septal defect and migraine.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2004,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Headache',
        'Journal Label AR': 'Headache',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1111/j.1526-4610.2004.t01-2-04063.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Reconciling evidence from ancient and contemporary genomes: a major source for the European Neolithic within Mediterranean Europe.',
        'Research Title AR': 'Reconciling evidence from ancient and contemporary genomes: a major source for the European Neolithic within Mediterranean Europe.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Proceedings. Biological sciences',
        'Journal Label AR': 'Proceedings. Biological sciences',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1098/rspb.2016.1976',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'White Matter Hyperintensities: Pearls and Pitfalls in Interpretation of MRI Abnormalities',
        'Research Title AR': 'White Matter Hyperintensities: Pearls and Pitfalls in Interpretation of MRI Abnormalities',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2004,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Stroke',
        'Journal Label AR': 'Stroke',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1161/01.str.0000142130.43394.38',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'Mechanism of organisational excellence as a mediator on the relationship between human resource management and organisational performance: empirical evidence from public sector',
        'Research Title AR': 'Mechanism of organisational excellence as a mediator on the relationship between human resource management and organisational performance: empirical evidence from public sector',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Quality & Reliability Management',
        'Journal Label AR': 'International Journal of Quality & Reliability Management',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/ijqrm-12-2019-0364',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hamad Alawar ',
        'Author Name AR': 'د. حمد العور',
        'Research Title EN': 'Vigilance Decrement and Enhancement Techniques: A Review',
        'Research Title AR': 'Vigilance Decrement and Enhancement Techniques: A Review',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Brain : a journal of neurology',
        'Journal Label AR': 'Brain : a journal of neurology',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.3390/brainsci9080178',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Is benign cough headache caused by intraocular haemodynamic aberration',
        'Research Title AR': 'Is benign cough headache caused by intraocular haemodynamic aberration',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2004,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Medical hypotheses',
        'Journal Label AR': 'Medical hypotheses',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/s0306-9877(03)00298-6',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'ASD closure for migraine: is there a scientific basis?',
        'Research Title AR': 'ASD closure for migraine: is there a scientific basis?',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2005,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'European heart journal',
        'Journal Label AR': 'European heart journal',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1093/eurheartj/ehi315',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'The mediating role of TQM and organizational excellence, and the moderating effect of entrepreneurial organizational culture on the relationship between ERP and organizational performance',
        'Research Title AR': 'The mediating role of TQM and organizational excellence, and the moderating effect of entrepreneurial organizational culture on the relationship between ERP and organizational performance',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'The TQM Journal',
        'Journal Label AR': 'The TQM Journal',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/tqm-04-2014-0040',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abbas A. Koronfel',
        'Author Name AR': 'عباس كورنوفيل',
        'Research Title EN': 'Suicide in Dubai, United Arab Emirates',
        'Research Title AR': 'Suicide in Dubai, United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2002,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of clinical forensic medicine',
        'Journal Label AR': 'Journal of clinical forensic medicine',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1054/jcfm.2002.0514',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'PopAffiliator: online calculator for individual affiliation to a major population group based on 17 autosomal short tandem repeat genotype profile.',
        'Research Title AR': 'PopAffiliator: online calculator for individual affiliation to a major population group based on 17 autosomal short tandem repeat genotype profile.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2010,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International journal of legal medicine',
        'Journal Label AR': 'International journal of legal medicine',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1007/s00414-010-0472-2',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'The effect of innovation and strategic planning on enhancing organizational performance of Dubai Police',
        'Research Title AR': 'The effect of innovation and strategic planning on enhancing organizational performance of Dubai Police',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Innovation & Management Review',
        'Journal Label AR': 'Innovation & Management Review',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1108/inmr-06-2018-0039',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Lisa Dunn',
        'Author Name AR': 'Lisa Dunn',
        'Research Title EN': 'Development and validation of fast liquid chromatography high-resolution mass spectrometric (LC-APCI-QToF-MS) methods for the analysis of hexamethylene triperoxide diamine (HMTD) and triacetone triperoxide (TATP)',
        'Research Title AR': 'Development and validation of fast liquid chromatography high-resolution mass spectrometric (LC-APCI-QToF-MS) methods for the analysis of hexamethylene triperoxide diamine (HMTD) and triacetone triperoxide (TATP)',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Chemistry',
        'Journal Label AR': 'Forensic Chemistry',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.forc.2018.06.003',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Does Hypomagnesemia Have an Adaptive Role in Hypertension',
        'Research Title AR': 'Does Hypomagnesemia Have an Adaptive Role in Hypertension',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2004,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Hypertension',
        'Journal Label AR': 'Hypertension',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1161/01.hyp.0000121463.32551.8f',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Muneer Dhaif Allah Saeed Eshaq',
        'Author Name AR': 'منير ضيف الله سعيد إسحاق العامري',
        'Research Title EN': 'The Effect of TQM and Innovation on Organizational Performance of Dubai Police: The Mediating Role of Organizational Culture',
        'Research Title AR': 'The Effect of TQM and Innovation on Organizational Performance of Dubai Police: The Mediating Role of Organizational Culture',
        'Department EN': 'General Department of Criminal Investigations (CID)',
        'Department AR': 'الإدارة العامة للتحريات والمباحث الجنائية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of Contemporary Issues and Thought',
        'Journal Label AR': 'Journal of Contemporary Issues and Thought',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.37134/jcit.vol12.2.4.2022',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Intravenous Magnesium for Neuroprotection in Acute Stroke: Clinical Hope Versus Basic Neuropharmacology',
        'Research Title AR': 'Intravenous Magnesium for Neuroprotection in Acute Stroke: Clinical Hope Versus Basic Neuropharmacology',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2004,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Stroke',
        'Journal Label AR': 'Stroke',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1161/01.str.0000147971.14988.50',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Faisal Al Teneiji',
        'Author Name AR': 'فيصل محمد احمد الطنيجي',
        'Research Title EN': 'The metabolism of the synthetic cannabinoids ADB-BUTINACA and ADB-4en-PINACA and their detection in forensic toxicology casework and infused papers seized in prisons',
        'Research Title AR': 'The metabolism of the synthetic cannabinoids ADB-BUTINACA and ADB-4en-PINACA and their detection in forensic toxicology casework and infused papers seized in prisons',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Drug testing and analysis',
        'Journal Label AR': 'Drug testing and analysis',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1002/dta.3203',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Meshgan Mohammad Al Awar',
        'Author Name AR': 'مشغان محمد العور',
        'Research Title EN': 'Using Satellite Images in Policing Urban Environments',
        'Research Title AR': 'Using Satellite Images in Policing Urban Environments',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2010,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Remote Sensing of Urban and Suburban Areas',
        'Journal Label AR': 'Remote Sensing of Urban and Suburban Areas',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1007/978-1-4020-4385-7_16',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Saleh Almazrouei',
        'Author Name AR': 'صالح حسن المرزوقي',
        'Research Title EN': 'INVESTIGATING THE ROLE OF TOTAL QUALITY MANAGEMENT, ENTREPRENEURIAL ORIENTATION, AND ORGANIZATIONAL EXCELLENCE IN DETERMINING THE ORGANIZATIONAL PERFORMANCE IN DUBAI POLICE',
        'Research Title AR': 'INVESTIGATING THE ROLE OF TOTAL QUALITY MANAGEMENT, ENTREPRENEURIAL ORIENTATION, AND ORGANIZATIONAL EXCELLENCE IN DETERMINING THE ORGANIZATIONAL PERFORMANCE IN DUBAI POLICE',
        'Department EN': 'General Department of Criminal Investigations (CID)',
        'Department AR': 'الإدارة العامة للتحريات والمباحث الجنائية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Law, Government and Communication',
        'Journal Label AR': 'International Journal of Law, Government and Communication',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.35631/ijlgc.729011',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulrahman Aljannahi',
        'Author Name AR': 'عبدالرحمن حسين الجناحي',
        'Research Title EN': 'Forensic Analysis of Textile Synthetic Fibers Using a FT-IR Spectroscopy Approach.',
        'Research Title AR': 'Forensic Analysis of Textile Synthetic Fibers Using a FT-IR Spectroscopy Approach.',
        'Department EN': 'General Department of Organization Protective Security and Emergency',
        'Department AR': 'الإدارة العامة لأمن الهيئات و المنشآت والطواري',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Molecules (Basel, Switzerland)',
        'Journal Label AR': 'Molecules (Basel, Switzerland)',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/molecules27134281',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Non‐lateralizing brain PET changes in migraine: phenomenology versus pharmacology?',
        'Research Title AR': 'Non‐lateralizing brain PET changes in migraine: phenomenology versus pharmacology?',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2004,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Brain : a journal of neurology',
        'Journal Label AR': 'Brain : a journal of neurology',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1093/brain/awh182',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed M. M. Al-Haj Mohd',
        'Author Name AR': 'محمد الحج',
        'Research Title EN': 'The predictors to medication adherence among adults with diabetes in the United Arab Emirates.',
        'Research Title AR': 'The predictors to medication adherence among adults with diabetes in the United Arab Emirates.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of diabetes and metabolic disorders',
        'Journal Label AR': 'Journal of diabetes and metabolic disorders',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1186/s40200-016-0254-6',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ibrahim Seba',
        'Author Name AR': 'إبراهيم سباع',
        'Research Title EN': 'Factors affecting attitudes and intentions towards knowledge sharing in the Dubai Police Force',
        'Research Title AR': 'Factors affecting attitudes and intentions towards knowledge sharing in the Dubai Police Force',
        'Department EN': 'General Department of Administrative Affairs',
        'Department AR': 'الإدارة العامة للشؤون الإدارية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2012,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Information Management',
        'Journal Label AR': 'International Journal of Information Management',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1016/j.ijinfomgt.2011.12.003',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Y chromosome in forensic casework and paternity testing',
        'Research Title AR': 'Y chromosome in forensic casework and paternity testing',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2004,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Congress Series',
        'Journal Label AR': 'International Congress Series',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1016/j.ics.2003.12.101',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Intractable cluster headache and therapeutic stimulation of the hypothalamus: pathophysiological and management insights from a rare experiment',
        'Research Title AR': 'Intractable cluster headache and therapeutic stimulation of the hypothalamus: pathophysiological and management insights from a rare experiment',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2005,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Brain : a journal of neurology',
        'Journal Label AR': 'Brain : a journal of neurology',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1093/brain/awh392',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ahmad AL-TAYER',
        'Author Name AR': 'احمد شعبان الطاير المري',
        'Research Title EN': 'Addressing the global climate change problem in GATT/WTO law: the vision of a new international climate law based on international distributive justice',
        'Research Title AR': 'Addressing the global climate change problem in GATT/WTO law: the vision of a new international climate law based on international distributive justice',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2011,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'The Journal of World Investment & Trade',
        'Journal Label AR': 'The Journal of World Investment & Trade',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.2139/ssrn.1969845',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Population history of the Red Sea—genetic exchanges between the Arabian Peninsula and East Africa signaled in the mitochondrial DNA HV1 haplogroup',
        'Research Title AR': 'Population history of the Red Sea—genetic exchanges between the Arabian Peninsula and East Africa signaled in the mitochondrial DNA HV1 haplogroup',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2011,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'American journal of physical anthropology',
        'Journal Label AR': 'American journal of physical anthropology',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1002/ajpa.21522',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Inflammation in atrial fibrillation and atherosclerosis: pearls and pitfalls in the theorising process.',
        'Research Title AR': 'Inflammation in atrial fibrillation and atherosclerosis: pearls and pitfalls in the theorising process.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2006,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International journal of clinical practice',
        'Journal Label AR': 'International journal of clinical practice',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1111/j.1368-5031.2006.0827a.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Evaluation of rapidly mutating Y-STRs in Pakistani population',
        'Research Title AR': 'Evaluation of rapidly mutating Y-STRs in Pakistani population',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.09.094',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Forensic and population genetic analysis of Serbian population using 21 STR loci of GlobalFiler™ PCR amplification kit',
        'Research Title AR': 'Forensic and population genetic analysis of Serbian population using 21 STR loci of GlobalFiler™ PCR amplification kit',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.09.020',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Sheikha Sanqoor',
        'Author Name AR': 'د. شيخة صنقور',
        'Research Title EN': 'A genetic overview of 23Y-STR markers in UAE population',
        'Research Title AR': 'A genetic overview of 23Y-STR markers in UAE population',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.fsigen.2016.04.009',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Population genetics-informed meta-analysis in seven genes associated with risk to dengue fever disease.',
        'Research Title AR': 'Population genetics-informed meta-analysis in seven genes associated with risk to dengue fever disease.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Infection, genetics and evolution : journal of molecular epidemiology and evolutionary genetics in infectious diseases',
        'Journal Label AR': 'Infection, genetics and evolution : journal of molecular epidemiology and evolutionary genetics in infectious diseases',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.meegid.2018.04.018',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Migraine, epilepsy, and brain neuronal hyperexcitation.',
        'Research Title AR': 'Migraine, epilepsy, and brain neuronal hyperexcitation.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2004,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Headache',
        'Journal Label AR': 'Headache',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1111/j.1526-4610.2005.05019.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'The Arabian Cradle: Mitochondrial Relicts of the First Steps along the Southern Route out of Africa',
        'Research Title AR': 'The Arabian Cradle: Mitochondrial Relicts of the First Steps along the Southern Route out of Africa',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2012,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'American journal of human genetics',
        'Journal Label AR': 'American journal of human genetics',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.ajhg.2011.12.010',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Investigation on rapidly mutating Y-STRs multiplex in Indian population: A pilot study',
        'Research Title AR': 'Investigation on rapidly mutating Y-STRs multiplex in Indian population: A pilot study',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.10.184',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Fawzi Benomran',
        'Author Name AR': 'فوزي عبدالسلام بن عمران',
        'Research Title EN': 'An unusual accidental death from positional asphyxia.',
        'Research Title AR': 'An unusual accidental death from positional asphyxia.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2011,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'The American journal of forensic medicine and pathology',
        'Journal Label AR': 'The American journal of forensic medicine and pathology',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1097/paf.0b013e3181f70d41',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ibrahim Seba',
        'Author Name AR': 'إبراهيم سباع',
        'Research Title EN': 'Knowledge Sharing in the Dubai Police Force Questionnaire',
        'Research Title AR': 'Knowledge Sharing in the Dubai Police Force Questionnaire',
        'Department EN': 'General Department of Administrative Affairs',
        'Department AR': 'الإدارة العامة للشؤون الإدارية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2012,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'PsycTESTS Dataset',
        'Journal Label AR': 'PsycTESTS Dataset',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1037/t34021-000',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'STR population diversity in nine ethnic populations living in Dubai',
        'Research Title AR': 'STR population diversity in nine ethnic populations living in Dubai',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2004,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2004.09.133',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Orbitofrontal cortex hypometabolism, medication overuse headache, substance abuse and migraine: key pathophysiological issues.',
        'Research Title AR': 'Orbitofrontal cortex hypometabolism, medication overuse headache, substance abuse and migraine: key pathophysiological issues.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2006,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Brain : a journal of neurology',
        'Journal Label AR': 'Brain : a journal of neurology',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1093/brain/awl119',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Fuad Ali Tarbah',
        'Author Name AR': 'د. فؤاد تربح',
        'Research Title EN': 'Distribution of dimethoate in the body after a fatal organphosphateintoxication',
        'Research Title AR': 'Distribution of dimethoate in the body after a fatal organphosphateintoxication',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2007,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2007.04.232',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': ' Dr. Rashed Humaid Alremeithi',
        'Author Name AR': 'د. راشد حميد الرميثي',
        'Research Title EN': 'A validated gas chromatography mass spectrometry method for simultaneous determination of cathinone related drug enantiomers in urine and plasma',
        'Research Title AR': 'A validated gas chromatography mass spectrometry method for simultaneous determination of cathinone related drug enantiomers in urine and plasma',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'RSC Advances',
        'Journal Label AR': 'RSC Advances',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1039/c6ra10583a',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mohammed Saleh Alosani',
        'Author Name AR': 'الدكتور محمد صالح العوساني',
        'Research Title EN': 'The mediating role of innovation culture on the relationship between Six Sigma and organisational performance in Dubai police force',
        'Research Title AR': 'The mediating role of innovation culture on the relationship between Six Sigma and organisational performance in Dubai police force',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Lean Six Sigma',
        'Journal Label AR': 'International Journal of Lean Six Sigma',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/ijlss-11-2019-0110',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'The Entrepreneurial Orientation and the Organizational Performance: Do Enterprise Resource Planning Systems Have a Mediating Role? A Study on Dubai Police',
        'Research Title AR': 'The Entrepreneurial Orientation and the Organizational Performance: Do Enterprise Resource Planning Systems Have a Mediating Role? A Study on Dubai Police',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2013,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Asian Social Science',
        'Journal Label AR': 'Asian Social Science',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.5539/ass.v10n2p257',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Conceptual divide between adaptive and pathogenetic phenomena in migraine: nausea and vomiting',
        'Research Title AR': 'Conceptual divide between adaptive and pathogenetic phenomena in migraine: nausea and vomiting',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2004,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Brain : a journal of neurology',
        'Journal Label AR': 'Brain : a journal of neurology',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1093/brain/awh279',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Distribution of HLA-DQA1 alleles in Arab and Pakistani individuals from Dubai, United Arab Emirates.',
        'Research Title AR': 'Distribution of HLA-DQA1 alleles in Arab and Pakistani individuals from Dubai, United Arab Emirates.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 1997,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/s0379-0738(97)02103-8',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Afrah Almansoori',
        'Author Name AR': 'عفراء المنصوري',
        'Research Title EN': 'AICV - Analysis of Cybercrime on Social Media Platforms and Its Challenges.',
        'Research Title AR': 'AICV - Analysis of Cybercrime on Social Media Platforms and Its Challenges.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Advances in Intelligent Systems and Computing',
        'Journal Label AR': 'Advances in Intelligent Systems and Computing',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1007/978-3-030-76346-6_54',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Sympathetic Nervous System Dysfunction in Migraine: Pearls and Pitfalls in the Theorizing Process',
        'Research Title AR': 'Sympathetic Nervous System Dysfunction in Migraine: Pearls and Pitfalls in the Theorizing Process',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2004,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Headache',
        'Journal Label AR': 'Headache',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1111/j.1526-4610.2004.04158_5.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'A Clinical Review of the Adaptive Role of Vasopressin in Migraine',
        'Research Title AR': 'A Clinical Review of the Adaptive Role of Vasopressin in Migraine',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 1997,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Cephalalgia : an international journal of headache',
        'Journal Label AR': 'Cephalalgia : an international journal of headache',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1046/j.1468-2982.1997.1705561.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Nasser Yousuf Mohammad Fakhari',
        'Author Name AR': 'ناصر يوسف محمد فخاري',
        'Research Title EN': 'Influence of Organizational Excellence Factors on the Organizational Performance and Moderation of Organizational Support in Dubai Police',
        'Research Title AR': 'Influence of Organizational Excellence Factors on the Organizational Performance and Moderation of Organizational Support in Dubai Police',
        'Department EN': 'General Department of Traffic',
        'Department AR': 'الإدارة العامة للمرور',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'South Asian Journal of Social Sciences and Humanities',
        'Journal Label AR': 'South Asian Journal of Social Sciences and Humanities',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.48165/sajssh.2021.2304',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Pre‐emptive/early intervention with triptans in migraine: hope, hype and hazard',
        'Research Title AR': 'Pre‐emptive/early intervention with triptans in migraine: hope, hype and hazard',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2007,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International journal of clinical practice',
        'Journal Label AR': 'International journal of clinical practice',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1111/j.1742-1241.2006.01072.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Nitric oxide and migraine: another systemic influence postulated to explain a lateralizing disorder',
        'Research Title AR': 'Nitric oxide and migraine: another systemic influence postulated to explain a lateralizing disorder',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 1996,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'European Journal of Neurology',
        'Journal Label AR': 'European Journal of Neurology',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1111/j.1468-1331.1996.tb00215.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Migraine, cortical excitability and evoked potentials: a clinico-pharmacological perspective.',
        'Research Title AR': 'Migraine, cortical excitability and evoked potentials: a clinico-pharmacological perspective.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2005,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Brain : a journal of neurology',
        'Journal Label AR': 'Brain : a journal of neurology',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1093/brain/awh606',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Migrainous stroke: are antiphospholipid antibodies pathogenetic, a biological epiphenomenon, or an incidental laboratory aberration?',
        'Research Title AR': 'Migrainous stroke: are antiphospholipid antibodies pathogenetic, a biological epiphenomenon, or an incidental laboratory aberration?',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 1996,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'European neurology',
        'Journal Label AR': 'European neurology',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1159/000117222',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulla Ahmed Zaher Omair Juma',
        'Author Name AR': 'عبدالله احمد زاهر عمير ',
        'Research Title EN': 'Model of Transformational Leadership, Risk Management  Factors Influencing on Law Performance',
        'Research Title AR': 'Model of Transformational Leadership, Risk Management  Factors Influencing on Law Performance',
        'Department EN': 'General Department of Organization Protective Security and Emergency',
        'Department AR': 'الإدارة العامة لأمن الهيئات و المنشآت والطواري',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Sustainable Construction Engineering and Technology',
        'Journal Label AR': 'International Journal of Sustainable Construction Engineering and Technology',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.30880/ijscet.2022.13.04.026',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Fawzi Benomran',
        'Author Name AR': 'فوزي عبدالسلام بن عمران',
        'Research Title EN': 'The Global Practice of Forensic Science - Forensic Medicine in Libya',
        'Research Title AR': 'The Global Practice of Forensic Science - Forensic Medicine in Libya',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2014,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'The Global Practice of Forensic Science',
        'Journal Label AR': 'The Global Practice of Forensic Science',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1002/9781118724248.ch19',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Should intellectual property be disseminated by \'forwarding\' rejected letters without permission?',
        'Research Title AR': 'Should intellectual property be disseminated by \'forwarding\' rejected letters without permission?',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 1996,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of medical ethics',
        'Journal Label AR': 'Journal of medical ethics',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1136/jme.22.4.243',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'The Expansion of mtDNA Haplogroup L3 within and out of Africa',
        'Research Title AR': 'The Expansion of mtDNA Haplogroup L3 within and out of Africa',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2011,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Molecular biology and evolution',
        'Journal Label AR': 'Molecular biology and evolution',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1093/molbev/msr245',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed M. M. Al-Haj Mohd',
        'Author Name AR': 'محمد الحج',
        'Research Title EN': 'Improving adherence to medication in adults with diabetes in the United Arab Emirates.',
        'Research Title AR': 'Improving adherence to medication in adults with diabetes in the United Arab Emirates.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'BMC public health',
        'Journal Label AR': 'BMC public health',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1186/s12889-016-3492-0',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mardeya Alblooshi',
        'Author Name AR': 'الدكتورة / مرضية البلوشي',
        'Research Title EN': 'Leadership in a military context: The case of the Dubai Police',
        'Research Title AR': 'Leadership in a military context: The case of the Dubai Police',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Deleted Journal',
        'Journal Label AR': 'Deleted Journal',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.34190/ecmlg.19.1.1971',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Bureaucratisation of migraine.',
        'Research Title AR': 'Bureaucratisation of migraine.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2004,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'The Lancet. Neurology',
        'Journal Label AR': 'The Lancet. Neurology',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/s1474-4422(04)00803-8',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mohammed Saleh Alosani',
        'Author Name AR': 'الدكتور محمد صالح العوساني',
        'Research Title EN': 'Case example of the use of Six Sigma and Kaizen projects in policing services',
        'Research Title AR': 'Case example of the use of Six Sigma and Kaizen projects in policing services',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Teaching Public Administration',
        'Journal Label AR': 'Teaching Public Administration',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1177/0144739420921932',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hazem Sherif',
        'Author Name AR': 'د. حازم متولى شريف',
        'Research Title EN': 'The use of dive computers in forensic investigations of fatal breath-hold diving accidents: a case study.',
        'Research Title AR': 'The use of dive computers in forensic investigations of fatal breath-hold diving accidents: a case study.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic science, medicine, and pathology',
        'Journal Label AR': 'Forensic science, medicine, and pathology',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1007/s12024-023-00700-8',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Noora Al Mutawa',
        'Author Name AR': 'د. نورة المطوع',
        'Research Title EN': 'Forensic investigation of cyberstalking cases using Behavioural Evidence Analysis',
        'Research Title AR': 'Forensic investigation of cyberstalking cases using Behavioural Evidence Analysis',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Digital Investigation',
        'Journal Label AR': 'Digital Investigation',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.diin.2016.01.012',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Fuad Ali Tarbah',
        'Author Name AR': 'د. فؤاد تربح',
        'Research Title EN': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Research Title AR': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.26735/rdvo3814',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Lootah',
        'Author Name AR': 'ريم لوتاه',
        'Research Title EN': 'Allelic and haplotype diversity of 12 X-STRs in the United Arab Emirates.',
        'Research Title AR': 'Allelic and haplotype diversity of 12 X-STRs in the United Arab Emirates.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.fsigen.2017.12.013',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Does vasopressin serve a vasomotor adaptive function in migraine',
        'Research Title AR': 'Does vasopressin serve a vasomotor adaptive function in migraine',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 1993,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Cephalalgia : an international journal of headache',
        'Journal Label AR': 'Cephalalgia : an international journal of headache',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1046/j.1468-2982.1993.1303214-6.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Evaluation of 13 rapidly mutating Y-STRs on a Dravidian pedigree',
        'Research Title AR': 'Evaluation of 13 rapidly mutating Y-STRs on a Dravidian pedigree',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.09.083',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'Role of leadership, strategic planning and entrepreneurial organizational culture towards achieving organizational excellence: evidence from public sector using SEM',
        'Research Title AR': 'Role of leadership, strategic planning and entrepreneurial organizational culture towards achieving organizational excellence: evidence from public sector using SEM',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Measuring Business Excellence',
        'Journal Label AR': 'Measuring Business Excellence',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/mbe-02-2021-0021',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Topiramate for migraine prophylaxis: addressing the blood-brain barrier-related pharmacokinetic-pathophysiological disconnect.',
        'Research Title AR': 'Topiramate for migraine prophylaxis: addressing the blood-brain barrier-related pharmacokinetic-pathophysiological disconnect.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2006,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International journal of clinical practice',
        'Journal Label AR': 'International journal of clinical practice',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1111/j.1368-5031.2006.0796a.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'Integration of TQM and ERP to enhance organizational performance and excellence: empirical evidence from public sector using SEM',
        'Research Title AR': 'Integration of TQM and ERP to enhance organizational performance and excellence: empirical evidence from public sector using SEM',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'World Journal of Entrepreneurship, Management and Sustainable Development',
        'Journal Label AR': 'World Journal of Entrepreneurship, Management and Sustainable Development',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1108/wjemsd-12-2020-0170',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Saeed Almarzooqi',
        'Author Name AR': 'سعيد احمد المرزوقي',
        'Research Title EN': 'E-Governance in Project Management: Impact and Risks of Implementation',
        'Research Title AR': 'E-Governance in Project Management: Impact and Risks of Implementation',
        'Department EN': 'Institutional Development Office',
        'Department AR': 'مكتب التطوير المؤسسي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'American Journal of Industrial and Business Management',
        'Journal Label AR': 'American Journal of Industrial and Business Management',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.4236/ajibm.2020.1012111',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Developmental validation of the DNAscan™ Rapid DNA Analysis™ instrument and expert system for reference sample processing',
        'Research Title AR': 'Developmental validation of the DNAscan™ Rapid DNA Analysis™ instrument and expert system for reference sample processing',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.fsigen.2016.08.008',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohamed SaadEldin',
        'Author Name AR': 'محمد سعد الدين محمد عبد الرسول',
        'Research Title EN': 'WorldCIST (1) - Building a Generic Model for Early Warning Information Systems (EWIS)',
        'Research Title AR': 'WorldCIST (1) - Building a Generic Model for Early Warning Information Systems (EWIS)',
        'Department EN': 'Future Foresight Center',
        'Department AR': 'مركز استشراف المستقبل',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'New Advances in Information Systems and Technologies',
        'Journal Label AR': 'New Advances in Information Systems and Technologies',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1007/978-3-319-31232-3_60',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Nadir Al Naqbi',
        'Author Name AR': 'نادر النقبي',
        'Research Title EN': 'The Influence of Social Media on Perceived Levels of National Security and Crisis: A Case Study of Youth in the United Arab Emirates',
        'Research Title AR': 'The Influence of Social Media on Perceived Levels of National Security and Crisis: A Case Study of Youth in the United Arab Emirates',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Sustainability',
        'Journal Label AR': 'Sustainability',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/su141710785',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'The importance of service design and information and analysis in enhancing organizational performance through a mechanism of organizational excellence in public sector organizations',
        'Research Title AR': 'The importance of service design and information and analysis in enhancing organizational performance through a mechanism of organizational excellence in public sector organizations',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Quality & Reliability Management',
        'Journal Label AR': 'International Journal of Quality & Reliability Management',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/ijqrm-02-2021-0035',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Internal Diversification of Mitochondrial Haplogroup R0a Reveals Post-Last Glacial Maximum Demographic Expansions in South Arabia',
        'Research Title AR': 'Internal Diversification of Mitochondrial Haplogroup R0a Reveals Post-Last Glacial Maximum Demographic Expansions in South Arabia',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2010,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Molecular biology and evolution',
        'Journal Label AR': 'Molecular biology and evolution',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1093/molbev/msq178',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammad Ahmad AlSuwaidi',
        'Author Name AR': 'محمد احمد السويدي',
        'Research Title EN': 'Significance of Fingerprints in A Brutal Travel Bag Murder- A Case Report',
        'Research Title AR': 'Significance of Fingerprints in A Brutal Travel Bag Murder- A Case Report',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Medico-Legal Update',
        'Journal Label AR': 'Medico-Legal Update',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.37506/mlu.v20i1.390',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ali AlGahtani',
        'Author Name AR': 'على القحطاني',
        'Research Title EN': 'Identifying Demographic, Social and Professional Characteristics for Effective Disaster Risk Management—A Case Study of the Kingdom of Saudi Arabia',
        'Research Title AR': 'Identifying Demographic, Social and Professional Characteristics for Effective Disaster Risk Management—A Case Study of the Kingdom of Saudi Arabia',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Sustainability',
        'Journal Label AR': 'Sustainability',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/su142215399',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Allele frequency distributions and other population genetic parameters for 13 STR loci in a UAE local population from Dubai',
        'Research Title AR': 'Allele frequency distributions and other population genetic parameters for 13 STR loci in a UAE local population from Dubai',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2003,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Congress Series',
        'Journal Label AR': 'International Congress Series',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1016/s0531-5131(02)00625-8',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Botulinum toxin type A therapy for chronic tension-type headache: fact versus fiction.',
        'Research Title AR': 'Botulinum toxin type A therapy for chronic tension-type headache: fact versus fiction.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2005,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Pain',
        'Journal Label AR': 'Pain',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.pain.2005.03.033',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Tariq Zeyad',
        'Author Name AR': 'طارق زياد',
        'Research Title EN': 'Study of 27 Y-STR markers in United Arab Emirates population',
        'Research Title AR': 'Study of 27 Y-STR markers in United Arab Emirates population',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.fsir.2020.100057',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ali Mohammed AlMatrooshi',
        'Author Name AR': 'على محمد المطروشي',
        'Research Title EN': 'Supremacy of the Parliament and the Rule of Law in the UK: An Analysis',
        'Research Title AR': 'Supremacy of the Parliament and the Rule of Law in the UK: An Analysis',
        'Department EN': 'General Department of Human Rights',
        'Department AR': 'الإدارة العامة لحقوق الإنسان',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of European Studies (JES)',
        'Journal Label AR': 'Journal of European Studies (JES)',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.56384/jes.v40i1.332',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Sumaya Almansoori',
        'Author Name AR': 'د. سمية المنصوري',
        'Research Title EN': 'Oligogenic inheritance in severe adult obesity.',
        'Research Title AR': 'Oligogenic inheritance in severe adult obesity.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International journal of obesity (2005)',
        'Journal Label AR': 'International journal of obesity (2005)',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.1038/s41366-024-01476-9',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'mtDNA diversity in Sudan (East Africa)',
        'Research Title AR': 'mtDNA diversity in Sudan (East Africa)',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2008,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2007.10.118',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Does magnesium supplementation have any role in acute myocardial infarction ? No',
        'Research Title AR': 'Does magnesium supplementation have any role in acute myocardial infarction ? No',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 1996,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Cardiovascular drugs and therapy',
        'Journal Label AR': 'Cardiovascular drugs and therapy',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1007/bf02627952',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ghaith Ghanem Al-Suwaidi',
        'Author Name AR': 'غيث غانم السويدي',
        'Research Title EN': 'The Independence of the Public Prosecution Service in the UAE: Issues and Proposals for Reform',
        'Research Title AR': 'The Independence of the Public Prosecution Service in the UAE: Issues and Proposals for Reform',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2009,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Law Quarterly',
        'Journal Label AR': 'Arab Law Quarterly',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1163/157302509x415693',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Metoclopramide is not an analgesic: reflection on a premature scientific conclusion',
        'Research Title AR': 'Metoclopramide is not an analgesic: reflection on a premature scientific conclusion',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2006,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International journal of clinical practice',
        'Journal Label AR': 'International journal of clinical practice',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1111/j.1368-5031.2006.00939.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohamed Ishak',
        'Author Name AR': 'محمد إسحاق',
        'Research Title EN': 'The effect of body composition on strength and power in male and female students.',
        'Research Title AR': 'The effect of body composition on strength and power in male and female students.',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'BMC Sports Science, Medicine and Rehabilitation',
        'Journal Label AR': 'BMC Sports Science, Medicine and Rehabilitation',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1186/s13102-021-00376-z',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Population data on the PCR-based loci LDLR, GYPA, HBGG, D7S8, Gc, HLA-DQA1, and D1S80 from Arabs from Dubai',
        'Research Title AR': 'Population data on the PCR-based loci LDLR, GYPA, HBGG, D7S8, Gc, HLA-DQA1, and D1S80 from Arabs from Dubai',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 1996,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/0379-0738(96)01941-x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Interatrial shunt-associated migraine: serendipity, empiricism, hope, or hype?',
        'Research Title AR': 'Interatrial shunt-associated migraine: serendipity, empiricism, hope, or hype?',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2006,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Stroke',
        'Journal Label AR': 'Stroke',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1161/01.str.0000237167.80526.13',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ibrahim Seba',
        'Author Name AR': 'إبراهيم سباع',
        'Research Title EN': 'Knowledge sharing in the Dubai Police Force',
        'Research Title AR': 'Knowledge sharing in the Dubai Police Force',
        'Department EN': 'General Department of Administrative Affairs',
        'Department AR': 'الإدارة العامة للشؤون الإدارية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2012,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of Knowledge Management',
        'Journal Label AR': 'Journal of Knowledge Management',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1108/13673271211198972',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Jassem Abdulla',
        'Author Name AR': 'جاسم محمد حسن عبدالله',
        'Research Title EN': 'Determinants of job satisfaction in the UAE',
        'Research Title AR': 'Determinants of job satisfaction in the UAE',
        'Department EN': 'General Department of Human Resources',
        'Department AR': 'الإدارة العامة للموارد البشرية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2011,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Personnel Review',
        'Journal Label AR': 'Personnel Review',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/00483481111095555',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Genetic Stratigraphy of Key Demographic Events in Arabia',
        'Research Title AR': 'Genetic Stratigraphy of Key Demographic Events in Arabia',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2015,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'PloS one',
        'Journal Label AR': 'PloS one',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1371/journal.pone.0118625',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Characterization of Arabian Peninsula whole exomes: Contributing to the catalogue of human diversity.',
        'Research Title AR': 'Characterization of Arabian Peninsula whole exomes: Contributing to the catalogue of human diversity.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': ' iScience',
        'Journal Label AR': ' iScience',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.isci.2022.105336',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Migrainous scintillating scotoma and headache is ocular in origin: A new hypothesis',
        'Research Title AR': 'Migrainous scintillating scotoma and headache is ocular in origin: A new hypothesis',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2005,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Medical hypotheses',
        'Journal Label AR': 'Medical hypotheses',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.mehy.2005.11.010',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Bassem Badr',
        'Author Name AR': 'د. باسم حامد محمد بدر ',
        'Research Title EN': 'Cyproheptadine: a psychopharmacological treasure trove?',
        'Research Title AR': 'Cyproheptadine: a psychopharmacological treasure trove?',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'CNS spectrums',
        'Journal Label AR': 'CNS spectrums',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1017/s1092852921000250',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Motion sickness is linked to nystagmus-related trigeminal brain stem input: a new hypothesis.',
        'Research Title AR': 'Motion sickness is linked to nystagmus-related trigeminal brain stem input: a new hypothesis.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2005,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Medical hypotheses',
        'Journal Label AR': 'Medical hypotheses',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.mehy.2004.11.031',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'The Comoros Show the Earliest Austronesian Gene Flow into the Swahili Corridor.',
        'Research Title AR': 'The Comoros Show the Earliest Austronesian Gene Flow into the Swahili Corridor.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'American journal of human genetics',
        'Journal Label AR': 'American journal of human genetics',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.ajhg.2017.11.011',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'The intermediary role of organizational performance as a driver of total quality management and enterprise resource planning towards achieving organizational excellence: the moderating role of demographic factors',
        'Research Title AR': 'The intermediary role of organizational performance as a driver of total quality management and enterprise resource planning towards achieving organizational excellence: the moderating role of demographic factors',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'The TQM Journal',
        'Journal Label AR': 'The TQM Journal',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/tqm-12-2020-0302',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Amphetamine, migraine, and brain noradrenergic activation: contradictions in headache research.',
        'Research Title AR': 'Amphetamine, migraine, and brain noradrenergic activation: contradictions in headache research.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2006,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Headache',
        'Journal Label AR': 'Headache',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1111/j.1526-4610.2006.00321_3.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'The Mechanism of Employee Empowerment in Enhancing Service Innovation',
        'Research Title AR': 'The Mechanism of Employee Empowerment in Enhancing Service Innovation',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Business Research',
        'Journal Label AR': 'International Business Research',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.5539/ibr.v15n5p1',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Cortical Spreading Depression Is Neuroprotective: The Challenge of Basic Sciences',
        'Research Title AR': 'Cortical Spreading Depression Is Neuroprotective: The Challenge of Basic Sciences',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2005,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Headache',
        'Journal Label AR': 'Headache',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1111/j.1526-4610.2005.05039_1.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Fawzi Benomran',
        'Author Name AR': 'فوزي عبدالسلام بن عمران',
        'Research Title EN': 'Medical responsibility in the United Arab Emirates.',
        'Research Title AR': 'Medical responsibility in the United Arab Emirates.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2010,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of forensic and legal medicine',
        'Journal Label AR': 'Journal of forensic and legal medicine',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.jflm.2009.12.009',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Bassem Badr',
        'Author Name AR': 'د. باسم حامد محمد بدر ',
        'Research Title EN': 'Bupropion-myth-busting!',
        'Research Title AR': 'Bupropion-myth-busting!',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'CNS spectrums',
        'Journal Label AR': 'CNS spectrums',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1017/s1092852921000365',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Fawzi Benomran',
        'Author Name AR': 'فوزي عبدالسلام بن عمران',
        'Research Title EN': 'The medico-legal scene in Dubai: 2002-2007.',
        'Research Title AR': 'The medico-legal scene in Dubai: 2002-2007.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2009,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of forensic and legal medicine',
        'Journal Label AR': 'Journal of forensic and legal medicine',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.jflm.2009.01.007',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed Murad Abdulla',
        'Author Name AR': 'د. محمد مراد عبدالله',
        'Research Title EN': 'A Conversation with Lieutenant General Dhahi Khalfan Tamim, Commander‐in‐Chief of the Dubai Police, United Arab Emirates',
        'Research Title AR': 'A Conversation with Lieutenant General Dhahi Khalfan Tamim, Commander‐in‐Chief of the Dubai Police, United Arab Emirates',
        'Department EN': 'General Department of Community Happiness',
        'Department AR': 'الإدارة العامة لإسعاد المجتمع',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2007,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Police Practice and Research',
        'Journal Label AR': 'Police Practice and Research',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1080/15614260701218030',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Naser Ansari ',
        'Author Name AR': 'د. ناصر عونى انصاري',
        'Research Title EN': 'Nonsteroidal Anti-inflammatory Drugs, Disease-Modifying Antirheumatic Drugs, and Agents Used in Gout',
        'Research Title AR': 'Nonsteroidal Anti-inflammatory Drugs, Disease-Modifying Antirheumatic Drugs, and Agents Used in Gout',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2011,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Handbook of Drug Interactions',
        'Journal Label AR': 'Handbook of Drug Interactions',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1007/978-1-61779-222-9_11',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Lootah',
        'Author Name AR': 'ريم لوتاه',
        'Research Title EN': 'The genomic history of the Middle East',
        'Research Title AR': 'The genomic history of the Middle East',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Cell',
        'Journal Label AR': 'Cell',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.cell.2021.07.013',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Fuad Ali Tarbah',
        'Author Name AR': 'د. فؤاد تربح',
        'Research Title EN': 'Chromatographic hair analysis for natural kavalactones and their metabolites. A preliminary study',
        'Research Title AR': 'Chromatographic hair analysis for natural kavalactones and their metabolites. A preliminary study',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2013,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Annales de Toxicologie Analytique',
        'Journal Label AR': 'Annales de Toxicologie Analytique',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1051/ata/2013044',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Reduced volume for direct PCR amplification of blood reference samples using Identifiler® Direct and Globalfiler™ Express assays',
        'Research Title AR': 'Reduced volume for direct PCR amplification of blood reference samples using Identifiler® Direct and Globalfiler™ Express assays',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2017.09.118',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hussain Alghanim',
        'Author Name AR': 'د. حسين الغانم ',
        'Research Title EN': 'DNA methylation assay based on pyrosequencing for determination of smoking status.',
        'Research Title AR': 'DNA methylation assay based on pyrosequencing for determination of smoking status.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Electrophoresis',
        'Journal Label AR': 'Electrophoresis',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1002/elps.201800098',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Triptans to abort neurological symptoms of prodrome of migraine: fact or fiction?',
        'Research Title AR': 'Triptans to abort neurological symptoms of prodrome of migraine: fact or fiction?',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2005,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Headache',
        'Journal Label AR': 'Headache',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1111/j.1526-4610.2005.05121_2.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': '60,000 years of interactions between Central and Eastern Africa documented by major African mitochondrial haplogroup L2.',
        'Research Title AR': '60,000 years of interactions between Central and Eastern Africa documented by major African mitochondrial haplogroup L2.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2015,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Scientific reports',
        'Journal Label AR': 'Scientific reports',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1038/srep12526',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Healthcare Derived Smart Watches and Mobile Phones are Contaminated Niches to Multidrug Resistant and Highly Virulent Microbes.',
        'Research Title AR': 'Healthcare Derived Smart Watches and Mobile Phones are Contaminated Niches to Multidrug Resistant and Highly Virulent Microbes.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Infection and drug resistance',
        'Journal Label AR': 'Infection and drug resistance',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.2147/idr.s378524',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Farida Alshamali',
        'Author Name AR': 'د. فريدة الشمالي',
        'Research Title EN': 'Mitochondrial DNA control region variation in Dubai, United Arab Emirates',
        'Research Title AR': 'Mitochondrial DNA control region variation in Dubai, United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2007,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigen.2007.08.005',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'The mediating role of total quality management between the entrepreneurial orientation and the organizational performance',
        'Research Title AR': 'The mediating role of total quality management between the entrepreneurial orientation and the organizational performance',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'The TQM Journal',
        'Journal Label AR': 'The TQM Journal',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/tqm-03-2014-0033',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hussain Alghanim',
        'Author Name AR': 'د. حسين الغانم ',
        'Research Title EN': 'Development of DNA methylation markers for sperm, saliva and blood identification using pyrosequencing and qPCR/HRM.',
        'Research Title AR': 'Development of DNA methylation markers for sperm, saliva and blood identification using pyrosequencing and qPCR/HRM.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Analytical biochemistry',
        'Journal Label AR': 'Analytical biochemistry',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.ab.2020.113933',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Migraine-related vertigo: the challenge of the basic sciences.',
        'Research Title AR': 'Migraine-related vertigo: the challenge of the basic sciences.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2005,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Clinical neurology and neurosurgery',
        'Journal Label AR': 'Clinical neurology and neurosurgery',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.clineuro.2005.08.005',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammad Alsuwaidi',
        'Author Name AR': 'محمد السويدي ',
        'Research Title EN': 'Green synthesized gold nanoparticles with enhanced photocatalytic activity',
        'Research Title AR': 'Green synthesized gold nanoparticles with enhanced photocatalytic activity',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Materials Today: Proceedings',
        'Journal Label AR': 'Materials Today: Proceedings',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1016/j.matpr.2020.12.531',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Mutation rate at 13 rapidly mutating Y-STR loci in the population of Serbia',
        'Research Title AR': 'Mutation rate at 13 rapidly mutating Y-STR loci in the population of Serbia',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2017.09.171',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Silent or non-clinical infarct-like lesions in the posterior circulation territory in migraine: brain hypoperfusion or hyperperfusion?',
        'Research Title AR': 'Silent or non-clinical infarct-like lesions in the posterior circulation territory in migraine: brain hypoperfusion or hyperperfusion?',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2006,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Brain : a journal of neurology',
        'Journal Label AR': 'Brain : a journal of neurology',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1093/brain/awh697',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mohamad J. Altamimi',
        'Author Name AR': 'د. محمد جمال التميمي',
        'Research Title EN': 'Variability in the α and β anomer content of commercially available lactose.',
        'Research Title AR': 'Variability in the α and β anomer content of commercially available lactose.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International journal of pharmaceutics',
        'Journal Label AR': 'International journal of pharmaceutics',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.ijpharm.2018.10.061',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Botulinum toxin--a treatment for migraine? A systematic review.',
        'Research Title AR': 'Botulinum toxin--a treatment for migraine? A systematic review.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2006,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Pain',
        'Journal Label AR': 'Pain',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1111/j.1526-4637.2006.00216.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Metagenomic Sequencing and Reverse Transcriptase PCR Reveal That Mobile Phones and Environmental Surfaces Are Reservoirs of Multidrug-Resistant Superbugs and SARS-CoV-2.',
        'Research Title AR': 'Metagenomic Sequencing and Reverse Transcriptase PCR Reveal That Mobile Phones and Environmental Surfaces Are Reservoirs of Multidrug-Resistant Superbugs and SARS-CoV-2.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Frontiers in cellular and infection microbiology',
        'Journal Label AR': 'Frontiers in cellular and infection microbiology',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.3389/fcimb.2022.806077',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Ocular Compression Maneuver Aborts Benign Cough-Induced Headache',
        'Research Title AR': 'Ocular Compression Maneuver Aborts Benign Cough-Induced Headache',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2005,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Headache',
        'Journal Label AR': 'Headache',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1111/j.1526-4610.2005.05117_4.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohamed SaadEldin',
        'Author Name AR': 'محمد سعد الدين محمد عبد الرسول',
        'Research Title EN': 'Developing a Foresight Model for Law Enforcement Organizations to Detect and Analyze Future Challenges and Threats',
        'Research Title AR': 'Developing a Foresight Model for Law Enforcement Organizations to Detect and Analyze Future Challenges and Threats',
        'Department EN': 'Future Foresight Center',
        'Department AR': 'مركز استشراف المستقبل',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Information Systems and Technologies',
        'Journal Label AR': 'Information Systems and Technologies',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.1007/978-3-031-45648-0_31',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Rapidly mutating Y-STRs population data in the population of Serbia and haplotype probability assessment for forensic purposes',
        'Research Title AR': 'Rapidly mutating Y-STRs population data in the population of Serbia and haplotype probability assessment for forensic purposes',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2017.09.169',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ishaq Mohamed',
        'Author Name AR': 'إسحاق محمد',
        'Research Title EN': 'The Effect Of Body Composition On Strenght An Power In Male And Female Students',
        'Research Title AR': 'The Effect Of Body Composition On Strenght An Power In Male And Female Students',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'BMC Sports Science, Medicine and Rehabilitation',
        'Journal Label AR': 'BMC Sports Science, Medicine and Rehabilitation',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.21203/rs.3.rs-370358/v1',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Maryam Sultan Ali Al Khatri',
        'Author Name AR': 'مريم سلطان على الخاطري',
        'Research Title EN': 'Expert considerations and consensus for using dogs to detect human SARS-CoV-2-infections.',
        'Research Title AR': 'Expert considerations and consensus for using dogs to detect human SARS-CoV-2-infections.',
        'Department EN': 'General Department of Organization Protective Security and Emergency',
        'Department AR': 'الإدارة العامة لأمن الهيئات و المنشآت والطواري',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Frontiers in medicine',
        'Journal Label AR': 'Frontiers in medicine',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.3389/fmed.2022.1015620',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulla Ahmed Zaher Omair Juma',
        'Author Name AR': 'عبدالله احمد زاهر عمير ',
        'Research Title EN': 'Exploratory Analysis of Risk Management Process of UAE Police Department',
        'Research Title AR': 'Exploratory Analysis of Risk Management Process of UAE Police Department',
        'Department EN': 'General Department of Organization Protective Security and Emergency',
        'Department AR': 'الإدارة العامة لأمن الهيئات و المنشآت والطواري',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Sustainable Construction Engineering and Technology',
        'Journal Label AR': 'International Journal of Sustainable Construction Engineering and Technology',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.30880/ijscet.2022.13.04.004',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Sumaya Almansoori',
        'Author Name AR': 'د. سمية المنصوري',
        'Research Title EN': 'Higher Waist Hip Ratio Genetic Risk Score Is Associated with Reduced Weight Loss in Patients with Severe Obesity Completing a Meal Replacement Programme.',
        'Research Title AR': 'Higher Waist Hip Ratio Genetic Risk Score Is Associated with Reduced Weight Loss in Patients with Severe Obesity Completing a Meal Replacement Programme.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of personalized medicine',
        'Journal Label AR': 'Journal of personalized medicine',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/jpm12111881',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Alya Hussain Mubarak',
        'Author Name AR': 'علياء حسين مبارك البلوشي',
        'Research Title EN': 'WorldCIST (1) - Evaluating the Effectiveness of the Early Warning Information System (EWIS)',
        'Research Title AR': 'WorldCIST (1) - Evaluating the Effectiveness of the Early Warning Information System (EWIS)',
        'Department EN': 'Future Foresight Center',
        'Department AR': 'مركز استشراف المستقبل',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Advances in Intelligent Systems and Computing',
        'Journal Label AR': 'Advances in Intelligent Systems and Computing',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1007/978-3-319-56535-4_72',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Huda Sulaiman Saeed',
        'Author Name AR': 'هدى سليمان سعيد سليمان',
        'Research Title EN': 'Designer benzodiazepines versus prescription benzodiazepines: can structural relation predict the next step?',
        'Research Title AR': 'Designer benzodiazepines versus prescription benzodiazepines: can structural relation predict the next step?',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Critical reviews in toxicology',
        'Journal Label AR': 'Critical reviews in toxicology',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1080/10408444.2021.1907303',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Salman Essa Hussain Alsalman',
        'Author Name AR': 'سلمان عيسى السلمان',
        'Research Title EN': 'Examining the Influence of Social Media Communication Management on Service Quality in the UAE Public Sector',
        'Research Title AR': 'Examining the Influence of Social Media Communication Management on Service Quality in the UAE Public Sector',
        'Department EN': 'General Department Deputy Chief of Police and General Security',
        'Department AR': 'الإدارة العامة لمكتب نائب رئيس الشرطة والامن',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Intellectual Human Resource Management (IJIHRM)',
        'Journal Label AR': 'International Journal of Intellectual Human Resource Management (IJIHRM)',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.46988/ijihrm.04.01.2023.006',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'Impact of total quality management, organisational excellence and entrepreneurial orientation on organisational performance: empirical evidence from the public sector in UAE',
        'Research Title AR': 'Impact of total quality management, organisational excellence and entrepreneurial orientation on organisational performance: empirical evidence from the public sector in UAE',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Benchmarking: An International Journal',
        'Journal Label AR': 'Benchmarking: An International Journal',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/bij-02-2020-0082',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Younis Albalooshi',
        'Author Name AR': 'د. يونس البلوشي',
        'Research Title EN': 'The Importance of Bloodstain Pattern Analysis in the Investigation of Road Traffic Accidents: A Case Report',
        'Research Title AR': 'The Importance of Bloodstain Pattern Analysis in the Investigation of Road Traffic Accidents: A Case Report',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2015,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.12816/0017703',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohamed Saif Al-Zaffin',
        'Author Name AR': 'محمد سيف الزفين',
        'Research Title EN': 'Trends and Causes of Traffic Accidents in Dubai',
        'Research Title AR': 'Trends and Causes of Traffic Accidents in Dubai',
        'Department EN': 'General Department of Traffic',
        'Department AR': 'الإدارة العامة للمرور',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2015,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of Civil Engineering and Architecture',
        'Journal Label AR': 'Journal of Civil Engineering and Architecture',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.17265/1934-7359/2015.02.011',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'The Relationship between Enterprise Resource Planning, Total Quality Management, Organizational Excellence, and Organizational Performance-the Mediating Role of Total Quality Management and Organizational Excellence',
        'Research Title AR': 'The Relationship between Enterprise Resource Planning, Total Quality Management, Organizational Excellence, and Organizational Performance-the Mediating Role of Total Quality Management and Organizational Excellence',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2014,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Asian Social Science',
        'Journal Label AR': 'Asian Social Science',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.5539/ass.v10n14p158',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Meshgan Mohammad Al Awar',
        'Author Name AR': 'مشغان محمد العور',
        'Research Title EN': 'Delineation of groundwater potential (GWP) in the northern United Arab Emirates and Oman using geospatial technologies in conjunction with Simple Additive Weight (SAW), Analytical Hierarchy Process (AHP), and Probabilistic Frequency Ratio (PFR) techniques',
        'Research Title AR': 'Delineation of groundwater potential (GWP) in the northern United Arab Emirates and Oman using geospatial technologies in conjunction with Simple Additive Weight (SAW), Analytical Hierarchy Process (AHP), and Probabilistic Frequency Ratio (PFR) techniques',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of Arid Environments',
        'Journal Label AR': 'Journal of Arid Environments',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.jaridenv.2018.05.005',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Suaad Alshehhi',
        'Author Name AR': 'د. سعاد الشحي ',
        'Research Title EN': 'An investigation of 21 insertion deletion markers in United Arab Emirates population',
        'Research Title AR': 'An investigation of 21 insertion deletion markers in United Arab Emirates population',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2015,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2015.09.104',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Saeed Matar Aljaberi',
        'Author Name AR': 'سعيد مطر الجابري',
        'Research Title EN': 'Automated Deep Learning based Video Summarization Approach for Forest Fire Detection',
        'Research Title AR': 'Automated Deep Learning based Video Summarization Approach for Forest Fire Detection',
        'Department EN': 'General Department of Artificial Intelligence',
        'Department AR': 'الإدارة العامة للذكاء الإصطناعي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Zenodo (CERN European Organization for Nuclear Research)',
        'Journal Label AR': 'Zenodo (CERN European Organization for Nuclear Research)',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.54216/JISIoT.050201',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ali Mohammed AlMatrooshi',
        'Author Name AR': 'على محمد المطروشي',
        'Research Title EN': 'The  Taxes in Islam and Islamic civilization from an Islamic perspective.',
        'Research Title AR': 'The  Taxes in Islam and Islamic civilization from an Islamic perspective.',
        'Department EN': 'General Department of Human Rights',
        'Department AR': 'الإدارة العامة لحقوق الإنسان',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Al-Idah',
        'Journal Label AR': 'Al-Idah',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.37556/al-idah.041.02.0855',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Vinod Kumar Gupta',
        'Author Name AR': 'Vinod Kumar Gupta',
        'Research Title EN': 'Migraine and sex hormones: epidemiological data stimulate rethinking of etiologic role of estrogen.',
        'Research Title AR': 'Migraine and sex hormones: epidemiological data stimulate rethinking of etiologic role of estrogen.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2004,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Headache',
        'Journal Label AR': 'Headache',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1111/j.1526-4610.2004.04181_2.x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Khalid Abdullah Shael Alsaadi',
        'Author Name AR': 'خالد عبدالله شاعل باروت السعدي',
        'Research Title EN': 'THE IMPACT OF TALENT MANAGEMENT ON LOYALTY AND ORGANIZATIONAL AFFILIATION: AN APPLIED STUDY ON THE DUBAI POLICE GENERAL COMMAND',
        'Research Title AR': 'THE IMPACT OF TALENT MANAGEMENT ON LOYALTY AND ORGANIZATIONAL AFFILIATION: AN APPLIED STUDY ON THE DUBAI POLICE GENERAL COMMAND',
        'Department EN': 'General Department of Artificial Intelligence',
        'Department AR': 'الإدارة العامة للذكاء الإصطناعي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Far East Journal of Mathematical Sciences (FJMS)',
        'Journal Label AR': 'Far East Journal of Mathematical Sciences (FJMS)',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.17654/ebm2022002',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'An evaluation of miniSTR markers for casework applications',
        'Research Title AR': 'An evaluation of miniSTR markers for casework applications',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2015,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2015.09.203',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mariam Al Shaer',
        'Author Name AR': 'مريم محمد الشاعر',
        'Research Title EN': 'The Internet of Things (IoT) Forensic Investigation Process',
        'Research Title AR': 'The Internet of Things (IoT) Forensic Investigation Process',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of Information Security and Cybercrimes Research',
        'Journal Label AR': 'Journal of Information Security and Cybercrimes Research',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.26735/dbeu2801',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mohammed Saleh Alosani',
        'Author Name AR': 'الدكتور محمد صالح العوساني',
        'Research Title EN': 'The integrated effect of Kaizen and innovation culture on the police performance: an empirical investigation',
        'Research Title AR': 'The integrated effect of Kaizen and innovation culture on the police performance: an empirical investigation',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'American Journal of Business',
        'Journal Label AR': 'American Journal of Business',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1108/ajb-02-2022-0024',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Mobile phones are hazardous microbial platforms warranting robust public health and biosecurity protocols.',
        'Research Title AR': 'Mobile phones are hazardous microbial platforms warranting robust public health and biosecurity protocols.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Scientific reports',
        'Journal Label AR': 'Scientific reports',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1038/s41598-022-14118-9',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Murad Al Mawajdeh',
        'Author Name AR': 'مراد مواجده',
        'Research Title EN': 'Business practice via social media platforms in the Emirate of Dubai as a model',
        'Research Title AR': 'Business practice via social media platforms in the Emirate of Dubai as a model',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Economics and Business Research',
        'Journal Label AR': 'International Journal of Economics and Business Research',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1504/ijebr.2022.126444',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulla Albastaki',
        'Author Name AR': 'عبدالله البستكي ',
        'Research Title EN': 'Population and mutational assessment of novel repeats in 13RM Y-STRs in unrelated males born in Gilgit, Pakistan.',
        'Research Title AR': 'Population and mutational assessment of novel repeats in 13RM Y-STRs in unrelated males born in Gilgit, Pakistan.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Saudi journal of biological sciences',
        'Journal Label AR': 'Saudi journal of biological sciences',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.sjbs.2022.01.055',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'Organizational Excellence as the Driver for Organizational Performance: A Study on Dubai Police',
        'Research Title AR': 'Organizational Excellence as the Driver for Organizational Performance: A Study on Dubai Police',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Business and Management',
        'Journal Label AR': 'International Journal of Business and Management',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.5539/ijbm.v11n2p47',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hareb Hamad Hareb Alkuwaiti',
        'Author Name AR': 'حارب حمد حارب الكويتي',
        'Research Title EN': 'Exemption From the Contractual Responsibility and The Extent of Its Legitimacy',
        'Research Title AR': 'Exemption From the Contractual Responsibility and The Extent of Its Legitimacy',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Membrane Science and Technology',
        'Journal Label AR': 'International Journal of Membrane Science and Technology',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.15379/ijmst.v10i4.2048',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Shaima Saeed Almazrouei',
        'Author Name AR': 'شيماء سعيد سالم المزروعي',
        'Research Title EN': 'Safeguarding Online Communications using DistilRoBERTa for Detection of Terrorism and Offensive Chats',
        'Research Title AR': 'Safeguarding Online Communications using DistilRoBERTa for Detection of Terrorism and Offensive Chats',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of Information Security and Cybercrimes Research',
        'Journal Label AR': 'Journal of Information Security and Cybercrimes Research',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.26735/vnvr2791',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Aisha Juma Alblooshi',
        'Author Name AR': 'عائشه جمعه نور البلوشي',
        'Research Title EN': 'Patients\' Knowledge and Pharmacists\' Practice Regarding the Long-Term Side Effects of Proton Pump Inhibitors; a Cross-sectional Study.',
        'Research Title AR': 'Patients\' Knowledge and Pharmacists\' Practice Regarding the Long-Term Side Effects of Proton Pump Inhibitors; a Cross-sectional Study.',
        'Department EN': 'Dubai Police Health Center',
        'Department AR': 'مركز شرطة دبي الصحي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Archives of academic emergency medicine',
        'Journal Label AR': 'Archives of academic emergency medicine',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.22037/aaem.v12i1.2305',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Ashraf Barkawi',
        'Author Name AR': 'د. اشرف برقاوي',
        'Research Title EN': 'Molecular, enzymatic responses and in vitro embryonic developmental competency of heat-shocked buffalo embryos co-cultured with granulosa cells monolayer.',
        'Research Title AR': 'Molecular, enzymatic responses and in vitro embryonic developmental competency of heat-shocked buffalo embryos co-cultured with granulosa cells monolayer.',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Theriogenology',
        'Journal Label AR': 'Theriogenology',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.theriogenology.2023.08.009',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Saeed Matar Aljaberi',
        'Author Name AR': 'سعيد مطر الجابري',
        'Research Title EN': 'Modeling of Deep Learning based Intrusion Detection System in Internet of Things Environment',
        'Research Title AR': 'Modeling of Deep Learning based Intrusion Detection System in Internet of Things Environment',
        'Department EN': 'General Department of Artificial Intelligence',
        'Department AR': 'الإدارة العامة للذكاء الإصطناعي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Zenodo (CERN European Organization for Nuclear Research)',
        'Journal Label AR': 'Zenodo (CERN European Organization for Nuclear Research)',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.5281/zenodo.5501286',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Study of insertion-deletion polymorphisms (indels) in the UAE population',
        'Research Title AR': 'Study of insertion-deletion polymorphisms (indels) in the UAE population',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.10.090',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed Ali Qassim',
        'Author Name AR': 'محمد على القاسم',
        'Research Title EN': 'The Role of Forensic Engineering in the Diagnosis of Electrocution Fatalities: Two Case Reports.',
        'Research Title AR': 'The Role of Forensic Engineering in the Diagnosis of Electrocution Fatalities: Two Case Reports.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Safety and health at work',
        'Journal Label AR': 'Safety and health at work',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.shaw.2022.11.002',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Wastewater surveillance for bacterial targets: current challenges and future goals.',
        'Research Title AR': 'Wastewater surveillance for bacterial targets: current challenges and future goals.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Applied and environmental microbiology',
        'Journal Label AR': 'Applied and environmental microbiology',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.1128/aem.01428-23',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mardeya Alblooshi',
        'Author Name AR': 'الدكتورة / مرضية البلوشي',
        'Research Title EN': 'Police Leadership in Non-western Context: Evidence from the Dubai Police',
        'Research Title AR': 'Police Leadership in Non-western Context: Evidence from the Dubai Police',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'European Journal of Business and Management',
        'Journal Label AR': 'European Journal of Business and Management',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.7176/ejbm/16-3-14',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed Alwaeel',
        'Author Name AR': 'محمد على الوعيل',
        'Research Title EN': 'A comparative analysis of three different immunoassay techniques for screening of drugs of abuse in urine and their confirmation using GC-MS& HPLC-MS',
        'Research Title AR': 'A comparative analysis of three different immunoassay techniques for screening of drugs of abuse in urine and their confirmation using GC-MS& HPLC-MS',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'The Egyptian Journal of Forensic Sciences and Applied Toxicology',
        'Journal Label AR': 'The Egyptian Journal of Forensic Sciences and Applied Toxicology',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.21608/ejfsat.2022.96815.1224',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Saleh Almazrouei',
        'Author Name AR': 'صالح حسن المرزوقي',
        'Research Title EN': 'MEDIATING EFFECT OF TALENT MANAGEMENT ON THE RELATIONSHIP BETWEEN TOTAL QUALITY MANAGEMENT, ENTREPRENEURIAL ORIENTATION, ORGANIZATIONAL EXCELLENCE, AND ORGANIZATIONAL PERFORMANCE IN DUBAI POLICE',
        'Research Title AR': 'MEDIATING EFFECT OF TALENT MANAGEMENT ON THE RELATIONSHIP BETWEEN TOTAL QUALITY MANAGEMENT, ENTREPRENEURIAL ORIENTATION, ORGANIZATIONAL EXCELLENCE, AND ORGANIZATIONAL PERFORMANCE IN DUBAI POLICE',
        'Department EN': 'General Department of Criminal Investigations (CID)',
        'Department AR': 'الإدارة العامة للتحريات والمباحث الجنائية',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Law, Government and Communication',
        'Journal Label AR': 'International Journal of Law, Government and Communication',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.35631/ijlgc.729012',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mohamad J. Altamimi',
        'Author Name AR': 'د. محمد جمال التميمي',
        'Research Title EN': 'State-of-the-Art Analytical Approaches for Illicit Drug Profiling in Forensic Investigations.',
        'Research Title AR': 'State-of-the-Art Analytical Approaches for Illicit Drug Profiling in Forensic Investigations.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Molecules (Basel, Switzerland)',
        'Journal Label AR': 'Molecules (Basel, Switzerland)',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/molecules27196602',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': ' Mohammad AlShamsi',
        'Author Name AR': 'محمد الشامسي ',
        'Research Title EN': 'AICV - Analysis of Cybercrime on Social Media Platforms and Its Challenges.',
        'Research Title AR': 'AICV - Analysis of Cybercrime on Social Media Platforms and Its Challenges.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Advances in Intelligent Systems and Computing',
        'Journal Label AR': 'Advances in Intelligent Systems and Computing',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1007/978-3-030-76346-6_54',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mohammed Saleh Alosani',
        'Author Name AR': 'الدكتور محمد صالح العوساني',
        'Research Title EN': 'Closing the strategic planning and implementation gap through excellence in the public sector: empirical investigation using SEM',
        'Research Title AR': 'Closing the strategic planning and implementation gap through excellence in the public sector: empirical investigation using SEM',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Measuring Business Excellence',
        'Journal Label AR': 'Measuring Business Excellence',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/mbe-12-2019-0128',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mohammed Saleh Alosani',
        'Author Name AR': 'الدكتور محمد صالح العوساني',
        'Research Title EN': 'Mechanism of organisational excellence as a mediator on the relationship between human resource management and organisational performance: empirical evidence from public sector',
        'Research Title AR': 'Mechanism of organisational excellence as a mediator on the relationship between human resource management and organisational performance: empirical evidence from public sector',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Quality & Reliability Management',
        'Journal Label AR': 'International Journal of Quality & Reliability Management',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/ijqrm-12-2019-0364',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mohammed Saleh Alosani',
        'Author Name AR': 'الدكتور محمد صالح العوساني',
        'Research Title EN': 'Role of leadership, strategic planning and entrepreneurial organizational culture towards achieving organizational excellence: evidence from public sector using SEM',
        'Research Title AR': 'Role of leadership, strategic planning and entrepreneurial organizational culture towards achieving organizational excellence: evidence from public sector using SEM',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Measuring Business Excellence',
        'Journal Label AR': 'Measuring Business Excellence',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/mbe-02-2021-0021',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mohammed Saleh Alosani',
        'Author Name AR': 'الدكتور محمد صالح العوساني',
        'Research Title EN': 'Integration of TQM and ERP to enhance organizational performance and excellence: empirical evidence from public sector using SEM',
        'Research Title AR': 'Integration of TQM and ERP to enhance organizational performance and excellence: empirical evidence from public sector using SEM',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'World Journal of Entrepreneurship, Management and Sustainable Development',
        'Journal Label AR': 'World Journal of Entrepreneurship, Management and Sustainable Development',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1108/wjemsd-12-2020-0170',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mohammed Saleh Alosani',
        'Author Name AR': 'الدكتور محمد صالح العوساني',
        'Research Title EN': 'The importance of service design and information and analysis in enhancing organizational performance through a mechanism of organizational excellence in public sector organizations',
        'Research Title AR': 'The importance of service design and information and analysis in enhancing organizational performance through a mechanism of organizational excellence in public sector organizations',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Quality & Reliability Management',
        'Journal Label AR': 'International Journal of Quality & Reliability Management',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/ijqrm-02-2021-0035',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mohammed Saleh Alosani',
        'Author Name AR': 'الدكتور محمد صالح العوساني',
        'Research Title EN': 'The intermediary role of organizational performance as a driver of total quality management and enterprise resource planning towards achieving organizational excellence: the moderating role of demographic factors',
        'Research Title AR': 'The intermediary role of organizational performance as a driver of total quality management and enterprise resource planning towards achieving organizational excellence: the moderating role of demographic factors',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'The TQM Journal',
        'Journal Label AR': 'The TQM Journal',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/tqm-12-2020-0302',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mohammed Saleh Alosani',
        'Author Name AR': 'الدكتور محمد صالح العوساني',
        'Research Title EN': 'Impact of total quality management, organisational excellence and entrepreneurial orientation on organisational performance: empirical evidence from the public sector in UAE',
        'Research Title AR': 'Impact of total quality management, organisational excellence and entrepreneurial orientation on organisational performance: empirical evidence from the public sector in UAE',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Benchmarking: An International Journal',
        'Journal Label AR': 'Benchmarking: An International Journal',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/bij-02-2020-0082',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdul Qader Al Khayat',
        'Author Name AR': 'عبدالقادر الخياط',
        'Research Title EN': 'Population data on the PCR-based loci LDLR, GYPA, HBGG, D7S8, Gc, HLA-DQA1, and D1S80 from Arabs from Dubai',
        'Research Title AR': 'Population data on the PCR-based loci LDLR, GYPA, HBGG, D7S8, Gc, HLA-DQA1, and D1S80 from Arabs from Dubai',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 1996,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1016/0379-0738(96)01941-x',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohamed SaadEldin',
        'Author Name AR': 'محمد سعد الدين محمد عبد الرسول',
        'Research Title EN': 'WorldCIST (1) - Evaluating the Effectiveness of the Early Warning Information System (EWIS)',
        'Research Title AR': 'WorldCIST (1) - Evaluating the Effectiveness of the Early Warning Information System (EWIS)',
        'Department EN': 'Future Foresight Center',
        'Department AR': 'مركز استشراف المستقبل',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Advances in Intelligent Systems and Computing',
        'Journal Label AR': 'Advances in Intelligent Systems and Computing',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1007/978-3-319-56535-4_72',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Lootah',
        'Author Name AR': 'ريم لوتاه',
        'Research Title EN': 'An evaluation of miniSTR markers for casework applications',
        'Research Title AR': 'An evaluation of miniSTR markers for casework applications',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2015,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2015.09.203',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Sulaiman Alzarooni',
        'Author Name AR': 'سليمان الزرعوني',
        'Research Title EN': 'Fatal automobile accident due to airbag misdeployment',
        'Research Title AR': 'Fatal automobile accident due to airbag misdeployment',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International journal of legal medicine',
        'Journal Label AR': 'International journal of legal medicine',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1007/s00414-020-02457-z',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed Eltabie',
        'Author Name AR': 'محمد التابعي',
        'Research Title EN': 'The Importance of Bloodstain Pattern Analysis in the Investigation of Road Traffic Accidents: A Case Report',
        'Research Title AR': 'The Importance of Bloodstain Pattern Analysis in the Investigation of Road Traffic Accidents: A Case Report',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2015,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.12816/0017703',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ahmed Adam',
        'Author Name AR': 'احمد ادم',
        'Research Title EN': 'Study of 27 Y-STR markers in United Arab Emirates population',
        'Research Title AR': 'Study of 27 Y-STR markers in United Arab Emirates population',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.fsir.2020.100057',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'An empirical examination of the relationship between benchmarking, innovation culture and organisational performance using structural equation modelling',
        'Research Title AR': 'An empirical examination of the relationship between benchmarking, innovation culture and organisational performance using structural equation modelling',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'The TQM Journal',
        'Journal Label AR': 'The TQM Journal',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/tqm-02-2020-0034',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'The integrated effect of Kaizen and innovation culture on the police performance: an empirical investigation',
        'Research Title AR': 'The integrated effect of Kaizen and innovation culture on the police performance: an empirical investigation',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'American Journal of Business',
        'Journal Label AR': 'American Journal of Business',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.1108/ajb-02-2022-0024',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mohammed Saleh Alosani',
        'Author Name AR': 'الدكتور محمد صالح العوساني',
        'Research Title EN': 'The Mechanism of Employee Empowerment in Enhancing Service Innovation',
        'Research Title AR': 'The Mechanism of Employee Empowerment in Enhancing Service Innovation',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Business Research',
        'Journal Label AR': 'International Business Research',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.5539/ibr.v15n5p1',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Mohammed Saleh Alosani',
        'Author Name AR': 'الدكتور محمد صالح العوساني',
        'Research Title EN': 'The effect of innovation and strategic planning on enhancing organizational performance of Dubai Police',
        'Research Title AR': 'The effect of innovation and strategic planning on enhancing organizational performance of Dubai Police',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Innovation & Management Review',
        'Journal Label AR': 'Innovation & Management Review',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.1108/inmr-06-2018-0039',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hassan Al-Dhaafri',
        'Author Name AR': 'الدكتور / حسن صالح الظافري',
        'Research Title EN': 'The mediating role of innovation culture on the relationship between Six Sigma and organisational performance in Dubai police force',
        'Research Title AR': 'The mediating role of innovation culture on the relationship between Six Sigma and organisational performance in Dubai police force',
        'Department EN': 'General Department of Excellence and Pioneering',
        'Department AR': 'الإدارة العامة للتميز و الريادة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'International Journal of Lean Six Sigma',
        'Journal Label AR': 'International Journal of Lean Six Sigma',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1108/ijlss-11-2019-0110',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Lotti Tajouri',
        'Author Name AR': 'Lotti Tajouri',
        'Research Title EN': 'Healthcare Derived Smart Watches and Mobile Phones are Contaminated Niches to Multidrug Resistant and Highly Virulent Microbes.',
        'Research Title AR': 'Healthcare Derived Smart Watches and Mobile Phones are Contaminated Niches to Multidrug Resistant and Highly Virulent Microbes.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Infection and drug resistance',
        'Journal Label AR': 'Infection and drug resistance',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.2147/idr.s378524',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Lotti Tajouri',
        'Author Name AR': 'Lotti Tajouri',
        'Research Title EN': 'Metagenomic Sequencing and Reverse Transcriptase PCR Reveal That Mobile Phones and Environmental Surfaces Are Reservoirs of Multidrug-Resistant Superbugs and SARS-CoV-2.',
        'Research Title AR': 'Metagenomic Sequencing and Reverse Transcriptase PCR Reveal That Mobile Phones and Environmental Surfaces Are Reservoirs of Multidrug-Resistant Superbugs and SARS-CoV-2.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Frontiers in cellular and infection microbiology',
        'Journal Label AR': 'Frontiers in cellular and infection microbiology',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.3389/fcimb.2022.806077',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Raneem Ewiss',
        'Author Name AR': 'رنيم عمادالدين عويس',
        'Research Title EN': 'The Role of Forensic Engineering in the Diagnosis of Electrocution Fatalities: Two Case Reports.',
        'Research Title AR': 'The Role of Forensic Engineering in the Diagnosis of Electrocution Fatalities: Two Case Reports.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Safety and health at work',
        'Journal Label AR': 'Safety and health at work',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.shaw.2022.11.002',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hamdah Al Ali',
        'Author Name AR': 'حمده ال على',
        'Research Title EN': 'The Role of Forensic Engineering in the Diagnosis of Electrocution Fatalities: Two Case Reports.',
        'Research Title AR': 'The Role of Forensic Engineering in the Diagnosis of Electrocution Fatalities: Two Case Reports.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Safety and health at work',
        'Journal Label AR': 'Safety and health at work',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.shaw.2022.11.002',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Naser Ansari ',
        'Author Name AR': 'د. ناصر عونى انصاري',
        'Research Title EN': 'A comparative analysis of three different immunoassay techniques for screening of drugs of abuse in urine and their confirmation using GC-MS& HPLC-MS',
        'Research Title AR': 'A comparative analysis of three different immunoassay techniques for screening of drugs of abuse in urine and their confirmation using GC-MS& HPLC-MS',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'The Egyptian Journal of Forensic Sciences and Applied Toxicology',
        'Journal Label AR': 'The Egyptian Journal of Forensic Sciences and Applied Toxicology',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.21608/ejfsat.2022.96815.1224',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': ' Dr. Rashed Humaid Alremeithi',
        'Author Name AR': 'د. راشد حميد الرميثي',
        'Research Title EN': 'The identification of drugs of abuse in E-cigarette samples seized in Dubai between 2016 and 2020.',
        'Research Title AR': 'The identification of drugs of abuse in E-cigarette samples seized in Dubai between 2016 and 2020.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2022.111233',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Samar Jamal Gewily',
        'Author Name AR': 'سمر جمال جويلي',
        'Research Title EN': 'The identification of drugs of abuse in E-cigarette samples seized in Dubai between 2016 and 2020.',
        'Research Title AR': 'The identification of drugs of abuse in E-cigarette samples seized in Dubai between 2016 and 2020.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2022.111233',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Saif Eldin Khalil',
        'Author Name AR': 'سيف الدين خليل',
        'Research Title EN': 'The identification of drugs of abuse in E-cigarette samples seized in Dubai between 2016 and 2020.',
        'Research Title AR': 'The identification of drugs of abuse in E-cigarette samples seized in Dubai between 2016 and 2020.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.forsciint.2022.111233',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Lotti Tajouri',
        'Author Name AR': 'Lotti Tajouri',
        'Research Title EN': 'Mobile phones are hazardous microbial platforms warranting robust public health and biosecurity protocols.',
        'Research Title AR': 'Mobile phones are hazardous microbial platforms warranting robust public health and biosecurity protocols.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Scientific reports',
        'Journal Label AR': 'Scientific reports',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1038/s41598-022-14118-9',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Lotti Tajouri',
        'Author Name AR': 'Lotti Tajouri',
        'Research Title EN': 'A pilot metagenomic study reveals that community derived mobile phones are reservoirs of viable pathogenic microbes',
        'Research Title AR': 'A pilot metagenomic study reveals that community derived mobile phones are reservoirs of viable pathogenic microbes',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Scientific reports',
        'Journal Label AR': 'Scientific reports',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1038/s41598-021-93622-w',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulla Albastaki',
        'Author Name AR': 'عبدالله البستكي ',
        'Research Title EN': 'A pilot metagenomic study reveals that community derived mobile phones are reservoirs of viable pathogenic microbes',
        'Research Title AR': 'A pilot metagenomic study reveals that community derived mobile phones are reservoirs of viable pathogenic microbes',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Scientific reports',
        'Journal Label AR': 'Scientific reports',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1038/s41598-021-93622-w',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Ultraviolet-C-Based Mobile Phone Sanitisation for Global Public Health and Infection Control.',
        'Research Title AR': 'Ultraviolet-C-Based Mobile Phone Sanitisation for Global Public Health and Infection Control.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Microorganisms',
        'Journal Label AR': 'Microorganisms',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/microorganisms11081876',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Lotti Tajouri',
        'Author Name AR': 'Lotti Tajouri',
        'Research Title EN': 'Ultraviolet-C-Based Mobile Phone Sanitisation for Global Public Health and Infection Control.',
        'Research Title AR': 'Ultraviolet-C-Based Mobile Phone Sanitisation for Global Public Health and Infection Control.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Microorganisms',
        'Journal Label AR': 'Microorganisms',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/microorganisms11081876',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashed Alghafri',
        'Author Name AR': 'د. راشد الغافري',
        'Research Title EN': 'Extended Reality Head-Mounted Displays Are Likely to Pose a Significant Risk in Medical Settings While Current Classification Remains as Non-Critical.',
        'Research Title AR': 'Extended Reality Head-Mounted Displays Are Likely to Pose a Significant Risk in Medical Settings While Current Classification Remains as Non-Critical.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Microorganisms',
        'Journal Label AR': 'Microorganisms',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.3390/microorganisms12040815',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Lotti Tajouri',
        'Author Name AR': 'Lotti Tajouri',
        'Research Title EN': 'Extended Reality Head-Mounted Displays Are Likely to Pose a Significant Risk in Medical Settings While Current Classification Remains as Non-Critical.',
        'Research Title AR': 'Extended Reality Head-Mounted Displays Are Likely to Pose a Significant Risk in Medical Settings While Current Classification Remains as Non-Critical.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Microorganisms',
        'Journal Label AR': 'Microorganisms',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.3390/microorganisms12040815',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Naima Aljanahi',
        'Author Name AR': 'نعيمة الجناحي',
        'Research Title EN': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods',
        'Research Title AR': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yskr7711',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Almheiri',
        'Author Name AR': 'ريم المهيري',
        'Research Title EN': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods',
        'Research Title AR': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yskr7711',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hanan Almulla',
        'Author Name AR': 'حنان الملا',
        'Research Title EN': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods',
        'Research Title AR': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yskr7711',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Sheikha Sanqoor',
        'Author Name AR': 'د. شيخة صنقور',
        'Research Title EN': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods',
        'Research Title AR': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yskr7711',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hussain Alghanim',
        'Author Name AR': 'د. حسين الغانم ',
        'Research Title EN': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods',
        'Research Title AR': 'Comparative Study of Two Semi-automated Forensic DNA Extraction Methods',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'Q4',
        'Citations': null,
        'DOI': '10.26735/yskr7711',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Amr Mohamed Abuaieta',
        'Author Name AR': 'عامر محمد ابوعطيه',
        'Research Title EN': 'Safeguarding Online Communications using DistilRoBERTa for Detection of Terrorism and Offensive Chats',
        'Research Title AR': 'Safeguarding Online Communications using DistilRoBERTa for Detection of Terrorism and Offensive Chats',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of Information Security and Cybercrimes Research',
        'Journal Label AR': 'Journal of Information Security and Cybercrimes Research',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.26735/vnvr2791',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Younis Albalooshi',
        'Author Name AR': 'يونس حسن البلوشي',
        'Research Title EN': 'The use of dive computers in forensic investigations of fatal breath-hold diving accidents: a case study.',
        'Research Title AR': 'The use of dive computers in forensic investigations of fatal breath-hold diving accidents: a case study.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic science, medicine, and pathology',
        'Journal Label AR': 'Forensic science, medicine, and pathology',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1007/s12024-023-00700-8',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ahmad Al Hashemi',
        'Author Name AR': 'احمد الهاشمي',
        'Research Title EN': 'The use of dive computers in forensic investigations of fatal breath-hold diving accidents: a case study.',
        'Research Title AR': 'The use of dive computers in forensic investigations of fatal breath-hold diving accidents: a case study.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic science, medicine, and pathology',
        'Journal Label AR': 'Forensic science, medicine, and pathology',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1007/s12024-023-00700-8',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Islam Feteaha',
        'Author Name AR': 'اسلام عبدالسلام فتيحه',
        'Research Title EN': 'The use of dive computers in forensic investigations of fatal breath-hold diving accidents: a case study.',
        'Research Title AR': 'The use of dive computers in forensic investigations of fatal breath-hold diving accidents: a case study.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic science, medicine, and pathology',
        'Journal Label AR': 'Forensic science, medicine, and pathology',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1007/s12024-023-00700-8',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Roudha Abdulla Alblooshi',
        'Author Name AR': 'روضه عبدالله البلوشي',
        'Research Title EN': 'Forensic Analysis of Textile Synthetic Fibers Using a FT-IR Spectroscopy Approach.',
        'Research Title AR': 'Forensic Analysis of Textile Synthetic Fibers Using a FT-IR Spectroscopy Approach.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Molecules (Basel, Switzerland)',
        'Journal Label AR': 'Molecules (Basel, Switzerland)',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/molecules27134281',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Noora Abdulkarim Ahli ',
        'Author Name AR': 'نوره عبدالكريم اهلي',
        'Research Title EN': 'Forensic Analysis of Textile Synthetic Fibers Using a FT-IR Spectroscopy Approach.',
        'Research Title AR': 'Forensic Analysis of Textile Synthetic Fibers Using a FT-IR Spectroscopy Approach.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Molecules (Basel, Switzerland)',
        'Journal Label AR': 'Molecules (Basel, Switzerland)',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/molecules27134281',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Asma Mohammed Askar',
        'Author Name AR': 'أسماء محمد صالح المردعي',
        'Research Title EN': 'Forensic Analysis of Textile Synthetic Fibers Using a FT-IR Spectroscopy Approach.',
        'Research Title AR': 'Forensic Analysis of Textile Synthetic Fibers Using a FT-IR Spectroscopy Approach.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Molecules (Basel, Switzerland)',
        'Journal Label AR': 'Molecules (Basel, Switzerland)',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/molecules27134281',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ikhlass Mohammed Albastaki',
        'Author Name AR': 'إخلاص محمد البستكي ',
        'Research Title EN': 'Forensic Analysis of Textile Synthetic Fibers Using a FT-IR Spectroscopy Approach.',
        'Research Title AR': 'Forensic Analysis of Textile Synthetic Fibers Using a FT-IR Spectroscopy Approach.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Molecules (Basel, Switzerland)',
        'Journal Label AR': 'Molecules (Basel, Switzerland)',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/molecules27134281',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohamed Mahmood Ahli',
        'Author Name AR': 'محمد محمود محمد اهلي',
        'Research Title EN': 'Forensic Analysis of Textile Synthetic Fibers Using a FT-IR Spectroscopy Approach.',
        'Research Title AR': 'Forensic Analysis of Textile Synthetic Fibers Using a FT-IR Spectroscopy Approach.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Molecules (Basel, Switzerland)',
        'Journal Label AR': 'Molecules (Basel, Switzerland)',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/molecules27134281',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Reem Lootah',
        'Author Name AR': 'ريم لوتاه',
        'Research Title EN': 'Mutation Rate Analysis of RM Y-STRs in Deep-Rooted Multi-Generational Punjabi Pedigrees from Pakistan.',
        'Research Title AR': 'Mutation Rate Analysis of RM Y-STRs in Deep-Rooted Multi-Generational Punjabi Pedigrees from Pakistan.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Genes',
        'Journal Label AR': 'Genes',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/genes13081403',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Afra Alreyami',
        'Author Name AR': 'عفراء سامي الريامي',
        'Research Title EN': 'Mutation Rate Analysis of RM Y-STRs in Deep-Rooted Multi-Generational Punjabi Pedigrees from Pakistan.',
        'Research Title AR': 'Mutation Rate Analysis of RM Y-STRs in Deep-Rooted Multi-Generational Punjabi Pedigrees from Pakistan.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Genes',
        'Journal Label AR': 'Genes',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/genes13081403',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Imran Almarri',
        'Author Name AR': 'عمران المري',
        'Research Title EN': 'Mutation Rate Analysis of RM Y-STRs in Deep-Rooted Multi-Generational Punjabi Pedigrees from Pakistan.',
        'Research Title AR': 'Mutation Rate Analysis of RM Y-STRs in Deep-Rooted Multi-Generational Punjabi Pedigrees from Pakistan.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Genes',
        'Journal Label AR': 'Genes',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/genes13081403',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Fuad Ali Tarbah',
        'Author Name AR': 'د. فؤاد تربح',
        'Research Title EN': 'The metabolism of the synthetic cannabinoids ADB-BUTINACA and ADB-4en-PINACA and their detection in forensic toxicology casework and infused papers seized in prisons',
        'Research Title AR': 'The metabolism of the synthetic cannabinoids ADB-BUTINACA and ADB-4en-PINACA and their detection in forensic toxicology casework and infused papers seized in prisons',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Drug testing and analysis',
        'Journal Label AR': 'Drug testing and analysis',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1002/dta.3203',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Huda Suleiman Saeed',
        'Author Name AR': 'هدى سليمان سعيد سليمان',
        'Research Title EN': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Research Title AR': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.26735/rdvo3814',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Rashid Almansoori',
        'Author Name AR': 'د. راشد المنصوري',
        'Research Title EN': 'Do mobile phone surfaces carry SARS-CoV-2 virus? A systematic review warranting the inclusion of a “6th” moment of hand hygiene in healthcare',
        'Research Title AR': 'Do mobile phone surfaces carry SARS-CoV-2 virus? A systematic review warranting the inclusion of a “6th” moment of hand hygiene in healthcare',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of infection and public health',
        'Journal Label AR': 'Journal of infection and public health',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.jiph.2023.08.017',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Lotti Tajouri',
        'Author Name AR': 'Lotti Tajouri',
        'Research Title EN': 'Do mobile phone surfaces carry SARS-CoV-2 virus? A systematic review warranting the inclusion of a “6th” moment of hand hygiene in healthcare',
        'Research Title AR': 'Do mobile phone surfaces carry SARS-CoV-2 virus? A systematic review warranting the inclusion of a “6th” moment of hand hygiene in healthcare',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of infection and public health',
        'Journal Label AR': 'Journal of infection and public health',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.jiph.2023.08.017',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohamed A. Almarri',
        'Author Name AR': 'د. محمد المري',
        'Research Title EN': 'Allelic and haplotype diversity of 12 X-STRs in the United Arab Emirates.',
        'Research Title AR': 'Allelic and haplotype diversity of 12 X-STRs in the United Arab Emirates.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2017,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/j.fsigen.2017.12.013',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdul Qader Al Khayat',
        'Author Name AR': 'عبدالقادر الخياط',
        'Research Title EN': 'Distribution of HLA-DQA1 alleles in Arab and Pakistani individuals from Dubai, United Arab Emirates.',
        'Research Title AR': 'Distribution of HLA-DQA1 alleles in Arab and Pakistani individuals from Dubai, United Arab Emirates.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 1997,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1016/s0379-0738(97)02103-8',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Abdulrahman Mohammad AlSuwaidi',
        'Author Name AR': 'عبدالرحمن محمد المهيري',
        'Research Title EN': 'Significance of Fingerprints in A Brutal Travel Bag Murder- A Case Report',
        'Research Title AR': 'Significance of Fingerprints in A Brutal Travel Bag Murder- A Case Report',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Medico-Legal Update',
        'Journal Label AR': 'Medico-Legal Update',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.37506/mlu.v20i1.390',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Jassim Mohammed Abdullah',
        'Author Name AR': 'جاسم محمد عبدالله',
        'Research Title EN': 'Significance of Fingerprints in A Brutal Travel Bag Murder- A Case Report',
        'Research Title AR': 'Significance of Fingerprints in A Brutal Travel Bag Murder- A Case Report',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2020,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Medico-Legal Update',
        'Journal Label AR': 'Medico-Legal Update',
        'Journal Rating ': 'Q0',
        'Citations': null,
        'DOI': '10.37506/mlu.v20i1.390',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Adnan Lanjawi',
        'Author Name AR': 'عدنان لنجاوي',
        'Research Title EN': 'Simultaneous Quantitative Determination of Synthetic Cathinone Enantiomers in Urine and Plasma Using GC-NCI-MS.',
        'Research Title AR': 'Simultaneous Quantitative Determination of Synthetic Cathinone Enantiomers in Urine and Plasma Using GC-NCI-MS.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of analytical methods in chemistry',
        'Journal Label AR': 'Journal of analytical methods in chemistry',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1155/2018/4396043',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Saif Eldin Khalil',
        'Author Name AR': 'سيف الدين خليل',
        'Research Title EN': 'A validated gas chromatography mass spectrometry method for simultaneous determination of cathinone related drug enantiomers in urine and plasma',
        'Research Title AR': 'A validated gas chromatography mass spectrometry method for simultaneous determination of cathinone related drug enantiomers in urine and plasma',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'RSC Advances',
        'Journal Label AR': 'RSC Advances',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.1039/c6ra10583a',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Khalid Alsumaiti',
        'Author Name AR': 'خالد السميطي',
        'Research Title EN': 'Simultaneous Quantitative Determination of Synthetic Cathinone Enantiomers in Urine and Plasma Using GC-NCI-MS.',
        'Research Title AR': 'Simultaneous Quantitative Determination of Synthetic Cathinone Enantiomers in Urine and Plasma Using GC-NCI-MS.',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of analytical methods in chemistry',
        'Journal Label AR': 'Journal of analytical methods in chemistry',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1155/2018/4396043',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Foued Ftaiti',
        'Author Name AR': 'فؤاد بن بلقاسم فتياتي',
        'Research Title EN': 'The effect of body composition on strength and power in male and female students.',
        'Research Title AR': 'The effect of body composition on strength and power in male and female students.',
        'Department EN': 'General Department of Community Happiness',
        'Department AR': 'الإدارة العامة لاسعاد المجتمع',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2021,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'BMC Sports Science, Medicine and Rehabilitation',
        'Journal Label AR': 'BMC Sports Science, Medicine and Rehabilitation',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1186/s13102-021-00376-z',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Naill Mohammad Momani',
        'Author Name AR': 'نايل الموماني',
        'Research Title EN': 'The Influence of Social Media on Perceived Levels of National Security and Crisis: A Case Study of Youth in the United Arab Emirates',
        'Research Title AR': 'The Influence of Social Media on Perceived Levels of National Security and Crisis: A Case Study of Youth in the United Arab Emirates',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Sustainability',
        'Journal Label AR': 'Sustainability',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/su141710785',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Ruksar Damji',
        'Author Name AR': 'Ruksar Damji',
        'Research Title EN': 'Investigation on rapidly mutating Y-STRs multiplex in Indian population: A pilot study',
        'Research Title AR': 'Investigation on rapidly mutating Y-STRs multiplex in Indian population: A pilot study',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2019,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.fsigss.2019.10.184',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Saif Eldin Khalil',
        'Author Name AR': 'سيف الدين خليل',
        'Research Title EN': 'Development and validation of fast liquid chromatography high-resolution mass spectrometric (LC-APCI-QToF-MS) methods for the analysis of hexamethylene triperoxide diamine (HMTD) and triacetone triperoxide (TATP)',
        'Research Title AR': 'Development and validation of fast liquid chromatography high-resolution mass spectrometric (LC-APCI-QToF-MS) methods for the analysis of hexamethylene triperoxide diamine (HMTD) and triacetone triperoxide (TATP)',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Chemistry',
        'Journal Label AR': 'Forensic Chemistry',
        'Journal Rating ': 'Q3',
        'Citations': null,
        'DOI': '10.1016/j.forc.2018.06.003',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Khawla AlShehhi',
        'Author Name AR': 'خوله حسن الشحي',
        'Research Title EN': 'The Internet of Things (IoT) Forensic Investigation Process',
        'Research Title AR': 'The Internet of Things (IoT) Forensic Investigation Process',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of Information Security and Cybercrimes Research',
        'Journal Label AR': 'Journal of Information Security and Cybercrimes Research',
        'Journal Rating ': 'Q1',
        'Citations': null,
        'DOI': '10.26735/dbeu2801',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Samia Abdulla',
        'Author Name AR': 'ساميه عبدالله إبراهيم',
        'Research Title EN': 'The Internet of Things (IoT) Forensic Investigation Process',
        'Research Title AR': 'The Internet of Things (IoT) Forensic Investigation Process',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2023,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Journal of Information Security and Cybercrimes Research',
        'Journal Label AR': 'Journal of Information Security and Cybercrimes Research',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.26735/dbeu2801',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Amna Alrazouqi',
        'Author Name AR': 'امنه الرزوقي',
        'Research Title EN': 'A genetic overview of 23Y-STR markers in UAE population',
        'Research Title AR': 'A genetic overview of 23Y-STR markers in UAE population',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2016,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.fsigen.2016.04.009',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Naill Mohammad Momani',
        'Author Name AR': 'نايل الموماني',
        'Research Title EN': 'Identifying Demographic, Social and Professional Characteristics for Effective Disaster Risk Management—A Case Study of the Kingdom of Saudi Arabia',
        'Research Title AR': 'Identifying Demographic, Social and Professional Characteristics for Effective Disaster Risk Management—A Case Study of the Kingdom of Saudi Arabia',
        'Department EN': 'Dubai Police Academy',
        'Department AR': 'اكاديمية شرطة دبي',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2022,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Sustainability',
        'Journal Label AR': 'Sustainability',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.3390/su142215399',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohammed Jaber Alfayumi',
        'Author Name AR': 'محمد جابر فهمي الفيومي',
        'Research Title EN': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Research Title AR': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.26735/rdvo3814',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hamda Ibrahim Belshala',
        'Author Name AR': 'حمده إبراهيم بالشالات',
        'Research Title EN': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Research Title AR': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.26735/rdvo3814',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Nasser Auni Ansari',
        'Author Name AR': 'ناصر عونى انصاري',
        'Research Title EN': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Research Title AR': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.26735/rdvo3814',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Hazem Sherif',
        'Author Name AR': 'د. حازم متولى شريف',
        'Research Title EN': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Research Title AR': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.26735/rdvo3814',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Hazem Metwali Sherief',
        'Author Name AR': 'محمد مصطفى عبدالقادر حبيب الله',
        'Research Title EN': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Research Title AR': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.26735/rdvo3814',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Faisal AL Teneiji',
        'Author Name AR': 'فيصل محمد احمد الطنيجي',
        'Research Title EN': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Research Title AR': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.26735/rdvo3814',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Dr. Ebtisam Alabdooli',
        'Author Name AR': 'د. ابتسام عبدالرحمن العبدولى',
        'Research Title EN': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Research Title AR': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.26735/rdvo3814',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Annasamy Sankar',
        'Author Name AR': 'Annasamy Sankar',
        'Research Title EN': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Research Title AR': 'A Case Report of Fatal Caffeine Intoxication: Nonspecific Postmortem Distribution',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2024,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Label AR': 'Arab Journal of Forensic Sciences and Forensic Medicine',
        'Journal Rating ': 'TBA',
        'Citations': null,
        'DOI': '10.26735/rdvo3814',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    },
    {
        'Author Name EN': 'Mohamed A. Almarri',
        'Author Name AR': 'د. محمد المري',
        'Research Title EN': 'Allelic and haplotype diversity of 12 X-STRs in the United Arab Emirates',
        'Research Title AR': 'Allelic and haplotype diversity of 12 X-STRs in the United Arab Emirates',
        'Department EN': 'General Department of Forensic Science and Criminology',
        'Department AR': 'الإدارة العامة للادلة الجنائية وعلم الجريمة',
        'Conference EN': null,
        'Conference AR': null,
        'Year': 2018,
        'Country EN': null,
        'Country AR': null,
        'Journal Label EN': 'Forensic Science International',
        'Journal Label AR': 'Forensic Science International',
        'Journal Rating ': 'Q2',
        'Citations': null,
        'DOI': '10.1016/j.fsigen.2017.12.013 ',
        'ORCHID ID': null,
        'Keywords EN': null,
        'Keywords AR': null,
        'Gender': null,
        'Nationality': null
    }
];